<template>
    <!-- contents -->
    <div id="contents">
        <div class="contents_wrap">
            <div class="bc_ico">
                <a href="JavaScript:" @click="goMain">{{$t('FIELD.GLOBAL.PAGEINFO.HOME')}}</a> <em><span class="sr_only">&gt;</span></em> {{$t('TITLE.SEARCH.RESULTS')}}
            </div>
            <!-- //breadcrumbs -->
            <h2 class="pg_title">{{$t('TITLE.SEARCH.RESULTS')}}</h2>
            <keep-alive>
                <base-search-area
                    :bToggle="true"
                    :isSearching="isSearching"
                    :pKeyword="keyword"
                    :topClass="'srchTop_wrap srchResult_wrap'"
                    :callSearchFunc="callSearchFunc"
                    @search-toggle="toggleSearching"
                />
            </keep-alive>

            <!-- 결과 영역 -->
            <div class="result_wrap">
                <!-- 연관검색어 영역 -->
                <dl v-if="relatedSearchWords && relatedSearchWords.length > 0" class="related_keywords">
                    <dt>{{$t('TITLE.SEARCH.RELATED.KWORD')}}</dt>
                    <dd>
                        <ul>
                            <li v-for="rel in relatedSearchWords" :key="rel.sympDesc">
                                <a href="JavaScript:" @click="clickRelSearchWord(rel)">{{rel.sympDesc}}</a>
                            </li>
                        </ul>
                    </dd>
                </dl>

                <p class="refine"><em>{{$t('TITLE.SEARCH.RESULT.FOR')}}</em> '{{params.keyword}}'</p>

                <!-- 1. Quick Downloads -->
                <section v-if="params.searchKind != 'K'" data-type="quick" :class="{active: toggle1}"><!-- 활성화시 active 클래스 -->
                    <div class="result_title" @click="toggle1 = !toggle1">
                        <em>{{$t('TITLE.SEARCH.QUICK.DOWNLOAD')}}</em>
                    </div>

                    <div v-if="toggle1" class="result_con">
                        <div class="loader_box quick_downs" style="display:none">
                            <div class="loader"><span class="sr_only">Loading...</span></div>
                        </div>
                        <!-- Quick Downloads - PC -->
                        <div v-if="quickDownloads.length > 0" class="table_modul table_scroll pc_only">
                            <table class="data_table_ty2">
                                <colgroup>
                                    <col width="155px">
                                    <col width="140px" v-for="col in columns" :key="col.boardId">
                                    <col width="140px">
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th>{{$t('FIELD.SEARCH.MODELS')}}</th>
                                        <th v-for="col in columns" :key="col.boardId" align="center">{{col.headerNm}}</th>
                                        <th>{{$t('FIELD.SEARCH.BOM')}}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="data in quickDownloads" :key="data.BMODEL_ID">
                                        <td class="text_center">
                                            <a href="JavaScript:"><em class="txt_point" @click="clickQcModel(data.BMODEL_ID)">{{data.BMODEL_ID}}</em></a>
                                        </td>
                                        <td class="text_center" v-for="sub in data.subValues" :key="sub.ID">
                                            <a v-if="sub.headId == 'CNT_EXPVP'" href="JavaScript:" @click="viewAttachFiles($event, data,sub.headId)">
                                                <em class="txt_point">{{sub.cntSum}}</em>
                                            </a>
                                            <!-- 3D Exploded View disabled
                                            <a v-if="sub.headId == 'CNT_3DEXPVW'" href="JavaScript:" @click="viewAttachFiles($event, data,sub.headId)">
                                                <em class="txt_point">{{sub.cntSum}}</em>
                                            </a>
                                            -->
                                            <a v-if="sub.headId != 'CNT_EXPVP' && sub.cntSum > 0 && sub.headId != 'CNT_3DEXPVW'" href="JavaScript:" @click="fileDownload(sub.nIndex, data)">
                                                <em class="txt_point">{{sub.cntSum}}</em>
                                            </a>
                                            <span v-if="sub.headId != 'CNT_EXPVP' && sub.cntSum == 0 && sub.headId != 'CNT_3DEXPVW'">{{sub.cntSum}}</span>
                                        </td>
                                        <td class="text_center"> <!-- BOM -->
                                            <a href="JavaScript:" class="ico_attach" @click="popupBomOpen(data)"><span class="sr_only">attach</span></a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <!-- //Quick Downloads - PC -->

                        <!-- Quick Downloads - Tablet/Mobile -->
                        <div v-if="quickDownloads.length > 0" class="table_modul tabmobile_only">
                            <table class="data_table_ty2">
                                <colgroup>
                                    <col width="70%">
                                    <col width="30%">
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th class="select_th" colspan="2">
                                            <select class="slt_white w100p" v-model="selModelCd" @change="changeQdnModel()">
                                                <option v-for="model in quickDownloads" :key="model.BMODEL_ID" :value="model.BMODEL_ID">{{model.BMODEL_ID}}</option>
                                            </select>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="sub in selModels" :key="sub.ID">
                                        <td>{{sub.headNm}}</td>
                                        <td class="text_center">
                                            <a v-if="sub.headId == 'CNT_EXPVP'" href="JavaScript:" @click="viewAttachFiles($event, {BMODEL_ID: selModelCd},sub.headId)">
                                                <em class="txt_point">{{sub.cntSum}}</em>
                                            </a>
                                            <!-- 3D Exploded View disabled
                                            <a v-if="sub.headId == 'CNT_3DEXPVW'" href="JavaScript:" @click="viewAttachFiles($event, {BMODEL_ID: selModelCd},sub.headId)">
                                                <em class="txt_point">{{sub.cntSum}}</em>
                                            </a>
                                            -->
                                            <a v-if="sub.headId != 'CNT_EXPVP' && sub.cntSum > 0 && sub.headId != 'CNT_3DEXPVW'" href="JavaScript:" @click="fileDownload(sub.nIndex, {BMODEL_ID: selModelCd})">
                                                <em class="txt_point">{{sub.cntSum}}</em>
                                            </a>
                                            <span v-if="sub.headId != 'CNT_EXPVP' && sub.cntSum == 0 && sub.headId != 'CNT_3DEXPVW'">{{sub.cntSum}}</span>
                                        </td>
                                    </tr>
                                    <tr v-if="selModelCd">
                                        <td>{{$t('FIELD.SEARCH.BOM')}}</td>
                                        <td class="text_center">
                                            <a href="JavaScript:" class="ico_attach" @click="popupBomOpen({BMODEL_ID: selModelCd})"><span class="sr_only">attach</span></a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <!-- //Quick Downloads - Tablet/Mobile -->

                        <div class="table_modul gridDown_wrap" v-if="qcdnAttachFiles.length > 0">
                            <div class="gridtop_wrap">
                                <em class="txt_info">{{$t('MESSAGE.SEARCH.REQ.EXPLORER')}}</em>
                                <div class="btn_wrap">
                                    <a href="http://skp.samsungcsportal.com/basis/page/Dejavu_Viewer.zip" class="btn_white" title=""><i class="ico_down"></i>Deju Vu</a>
                                    <a href="http://skp.samsungcsportal.com/basis/page/isoview7.cab" class="btn_white" title=""><i class="ico_down"></i>iso View</a>
                                </div>
                            </div>
                            <table class="data_table_ty3">
                                <colgroup>
                                    <col width="25%">
                                    <col width="20%">
                                    <col width="25%">
                                    <col width="*">
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th>{{$t('FIELD.GLOBAL.MODEL')}}</th>
                                        <th>{{$t('FIELD.GLOBAL.VERSION')}}</th>
                                        <th class="pc_only">{{$t('FIELD.SEARCH.WEB.VIEW')}}</th>
                                        <th>{{$t('FIELD.SEARCH.PDF')}}</th>
                                    </tr>
                                </thead>
                                <tbody class="text_center">
                                    <tr v-for="file in qcdnAttachFiles" :key="file.VERSION">
                                        <td>{{file.MODEL_CD}}</td>
                                        <td>{{file.VERSION}}</td>
                                        <td class="pc_only">
                                            <a href="JavaScript:" @click="popupHtmlOpen(file)" v-if="file.BOM_FILE_NAME" class="txt_link">{{$t('BUTTON.SEARCH.CLICK')}}</a>
                                        </td>
                                        <td>
                                            <a :href="'http://downloadcenter.samsung.com/content/' + file.PDF_PATH" target="_blank" class="txt_link">{{file.PDF_FILE_NAME}}</a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div v-if="quickDownloads && quickDownloads.length > 0" class="btn_wrap">
                            <a href="JavaScript:" class="btn_laodmore" @click="loadMoreSearch()">{{qcdnMoreMsg}} <em>(<i>{{quickDownloads.length}}</i>/{{qcdnTotalCount}})</em></a>
                        </div>
                        <ul v-if="qcdnTotalCount == 0" class="nodata_list">
                            <li>
                                <span>{{$t('MESSAGE.GLOBAL.NO.DATA')}}</span>
                            </li>
                        </ul>
                    </div>
                </section><!-- 1. End of Quick Downloads -->

                <!-- 2. Engineer Contents -->
                <section data-type="engineer" :class="{active: toggle2}"><!-- 활성화시 active 클래스 -->
                    <div class="result_title">
                        <div class="sort_wrap">
                            <a href="JavaScript:" @click="searchSortBy('rank')"    :class="{active: sortBy == 'rank'}">{{$t('BUTTON.FAST.RELEVANCY')}}</a>
                            <a href="JavaScript:" @click="searchSortBy('regdate')" :class="{active: sortBy == 'regdate'}">{{$t('TITLE.SEARCH.LATEST')}}</a>
                        </div>
                        <em @click="toggle2 = !toggle2">{{$t('TITLE.SEARCH.ENGINEER')}}</em>
                    </div>
                    <div v-if="toggle2" class="result_con">
                        <div class="loader_box srch_engine" style="display:none">
                            <div class="loader"><span class="sr_only">Loading...</span></div>
                        </div>
                        <ul class="knowledge_list">
                            <li v-for="cont in engrContents" :key="cont.keyId">
                                <a href="JavaScript:" @click="showDetailInfo($event, cont)">
                                    <em v-if="cont.iconType" :class="getIconClass(cont.iconType)">{{cont.iconType}}</em>
                                    <em v-if="cont.IMPORTANCE_YN == 'Y'" class="textcolor_important">[{{$t('FIELD.GLOBAL.IMPORTANT')}}]</em>
                                    <em v-else-if="cont.MUST_READ_YN == 'Y'" class="textcolor_must">[{{$t('FIELD.GLOBAL.MUSTREAD')}}]</em>
                                    <em v-html="cont.subject"></em>
                                    <em class="info_modifi">({{cont.corpName}}, {{cont.regDate}})</em>
                                </a>
                                <span class="icon_item">
                                    <a href="JavaScript:" class="ico_favorite" :class="{off: !cont.isFavorite}" @click="addFavorite($event, cont, 'F')"> <!-- Favorite -->
                                        <span class="tooltip2">{{$t('MESSAGE.GLOBAL.ADD.FAVOR')}}</span>
                                        <span class="sr_only">{{$t('BUTTON.FAST.FAVORITE')}}</span>
                                    </a>
                                    <a href="JavaScript:" class="ico_like" :class="{off: !cont.isLike}" @click="addFavorite($event, cont, 'L')"> <!-- Remommand -->
                                        <span class="tooltip2">{{$t('MESSAGE.GLOBAL.ADD.LIKE')}}</span>
                                        <span class="sr_only">{{$t('MESSAGE.GLOBAL.LIKE')}}</span>
                                    </a>
                                </span>
                                <span class="info">
                                    <em>{{cont.dispName}}</em>
                                    <em>{{cont.prodCd2}}</em>
                                    <em>{{$t('FIELD.FAST.MODEL')}} {{cont.modelNm}}</em>
                                    <em class="hit">{{$t('FIELD.FAST.HIT')}}<i>{{cont.hitCnt}}</i></em>
                                </span>

                                <!-- Tab area -->
                                <div class="view_desc">
                                    <!-- SCMS Contents 의 경우, Symptom 및 Serial 등 추가 항목 -->
                                    <table class="data_table_ty2 mb-20">
                                        <colgroup>
                                            <col width="20%">
                                            <col width="30%">
                                            <col width="20%">
                                            <col width="*">
                                        </colgroup>
                                        <tbody>
                                            <tr>
                                                <th class="text_left">{{ $t('FIELD.GLOBAL.REGISTERED.BY') }}</th>
                                                <td>
                                                    <ul class="in_dotlist">{{ detail.REG_USER }} ({{ detail.REG_DT }})</ul>
                                                </td>
                                                <th class="text_left">{{ $t('FIELD.GLOBAL.MODIFY.USER') }}</th>
                                                <td>
                                                    <ul class="in_dotlist">{{ detail.MODF_USER }} ({{ detail.MODF_DT }})</ul>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th class="text_left">{{ $t('FIELD.GLOBAL.SYMPTOM') }}</th>
                                                <td>
                                                    <ul class="in_dotlist" v-if="symptomList.length === 0">
                                                        <li>&nbsp;</li>
                                                    </ul>
                                                    <ul class="in_dotlist" v-else v-for="symptom in symptomList">
                                                        <li>{{ symptom.NAME }}</li>
                                                    </ul>
                                                </td>
                                                <!-- TODO Manufacture date ? -->
                                                <th class="text_left">{{ $t('FIELD.KNOWLEDGE.MANUFACTURE') }}</th>
                                                <td>
                                                    <ul class="in_dotlist" v-if="serialList.length === 0">
                                                        <li>&nbsp;</li>
                                                    </ul>
                                                    <ul class="in_dotlist" v-else v-for="serial in serialList">
                                                        <li>{{ serial.SERIAL_S }} ~ {{ serial.SERIAL_E }}</li>
                                                    </ul>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th class="text_left">{{ $t('FIELD.KNOWLEDGE.GUIDETYPE') }}</th>
                                                <td>{{ getGuideTypeName }}</td>
                                                <th class="text_left">{{ $t('FIELD.KNOWLEDGE.DEFECTTYPE') }}</th>
                                                <td>{{ getDefectTypeName }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <!-- //200420수정 E -->

                                    <div class="tab_wrap">
                                        <ul class="tab_menu_02 tab_menus">
                                            <li class="on" @click="changeTab($event, cont)"><a href="javascript:">{{ $t('FIELD.GLOBAL.DESCRIPTION') }}</a></li>
                                            <li @click="changeTab($event, cont)"><a href="javascript:">{{ $t('FIELD.GLOBAL.MODEL.LIST') }}</a></li>
                                            <li @click="changeTab($event, cont)"><a href="javascript:">{{ $t('FIELD.KNOWLEDGE.PARTSLISTS') }}</a></li>
                                            <li @click="changeTab($event, cont)"><a href="javascript:">{{ $t('FIELD.KNOWLEDGE.VERHISTORY') }}</a></li>
                                        </ul>
                                        <div class="tab_contents">
                                            <div class="tab_cont" v-html="KNOWLEDGE_DESC" />
                                            <div v-if="resultCount < 999" class="grid_total">{{$t('TITLE.TOTAL.COUNT')}} : <em>{{ resultCount | numberFormat }}</em></div>
                                            <div class="tab_cont">
                                                <toast-grid
                                                    :gridId="modelGridId + cont.keyId"
                                                    :ref="modelGridId + cont.keyId"
                                                    :data="modelList"
                                                    :columns="modelColumns"
                                                    :options="options"
                                                    :pageOptions="pageOptions"
                                                    :isTotalCount="false"
                                                />
                                            </div>
                                            <div class="tab_cont">
                                                <toast-grid
                                                    :gridId="partsGridId + cont.keyId"
                                                    :ref="partsGridId + cont.keyId"
                                                    :data="partsList"
                                                    :columns="partsColumns"
                                                    :options="options"
                                                    :pageOptions="pageOptions"
                                                    :isTotalCount="false"
                                                />
                                            </div>
                                            <div class="tab_cont">
                                                <!-- Version Tab -->
                                                <table class="data_table">
                                                    <colgroup>
                                                        <col align="center" width="20%">
                                                        <col align="center" width="30%" class="pc_only">
                                                        <col width="25%" class="pc_only">
                                                        <col align="center" width="*">
                                                    </colgroup>
                                                    <thead>
                                                        <tr>
                                                            <th align="center"><b>{{ $t('FIELD.GLOBAL.VERSION') }}</b></th>
                                                            <th align="center" class="pc_only"><b>{{ $t('FIELD.GLOBAL.DATE') }}</b></th>
                                                            <th align="center" class="pc_only"><b>{{ $t('FIELD.GLOBAL.EDITOR') }}</b></th>
                                                            <th align="center"><b>{{ $t('FIELD.GLOBAL.DETAILS') }}</b></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody class="text_center">
                                                        <tr v-for="(version) in versionList" :key="version.VERSION_NO">
                                                            <td>Ver.{{ version.VERSION_NO }}</td>
                                                            <td class="pc_only">{{ version.MODF_DT }}</td>
                                                            <td class="pc_only">{{ version.MODF_USER }}</td>
                                                             <td class="text_left">
                                                                {{ version.MODF_REASON }}
                                                             <!--
                                                                <a  v-if="idx > 0"
                                                                    href="javascript:"
                                                                    class="txt_link"
                                                                    @click="seeDetailPop(version.KNOWLEDGE_ID, version.VERSION_NO)"
                                                                >
                                                                    {{ $t('FIELD.KNOWLEDGE.SEE.DETAILS') }}
                                                                </a>
                                                             -->
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Attachment -->
                                    <innorix-download
                                        v-if="contAttaches && contAttaches.length > 0 && cont.active == cont.keyId"
                                        :uploadId="uploadId + cont.keyId"
                                        :serviceType="serviceType"
                                        :attachList="contAttaches"
                                        :fixWidth="irxWidth"
                                    />
                                    <!-- 200629수정 S -->
                                    <dl class="attachment_link" v-if="contAttaches.length > 0">
                                        <dt><a href="javascript:" class="txt_link" @click="toggleLink($event)">{{$t('MESSAGE.GLOBAL.TROUBLE.DOWN')}}</a></dt>
                                        <dd>
                                            <ul>
                                                <li v-for="file in contAttaches" :key="file.ENC_ATTCH_FILE_SEQ + file.ENC_TOKEN">
                                                    <a href="javascript:" @click="getDownloadUrl(file.ENC_ATTCH_FILE_SEQ, file.ENC_TOKEN)" class="txt_link">
                                                        <span class="ico_attach"></span> {{ file.FILE_NM }}
                                                    </a>
                                                </li>
                                            </ul>
                                        </dd>
                                    </dl>

                                    <!-- //Attachment -->
                                    <div class="btn_wrap text_center mt-40 pc_only"><!-- 200507수정(class 추가) -->
                                        <a href="JavaScript:" class="btn_white_ico" title="" @click="btnPrint(detail.KNOWLEDGE_ID)"><em class="ico_printer on"></em>Print</a>
                                    </div>
                                </div> <!-- End of Tab -->
                            </li>
                        </ul>
                        <div v-if="engrTotalCount > 0" class="btn_wrap">
                            <a href="JavaScript:" class="btn_laodmore" @click="loadMoreCont(30, engrTotalCount)">{{engrMoreMsg}}
                                <em v-if="engrTotalCount > 0">(<i>{{engrContents.length}}</i>/{{engrTotalCount}})</em>
                            </a>
                        </div>
                        <ul v-if="engrTotalCount == 0" class="nodata_list">
                            <li>
                                <span>{{$t('MESSAGE.GLOBAL.NO.DATA')}}</span>
                            </li>
                        </ul>
                    </div>
                </section><!-- 2. End of Engineer -->

                <!-- 3. Customer -->
                <section data-type="customer" :class="{active: toggle3}"><!-- 활성화시 active 클래스 -->
                    <div class="result_title" @click="toggle3 = !toggle3">
                        <em>{{$t('TITLE.SEARCH.CUSTOMER')}}</em>
                    </div>
                    <div v-if="toggle3" class="result_con">
                        <div class="loader_box srch_engine" style="display:none">
                            <div class="loader"><span class="sr_only">Loading...</span></div>
                        </div>
                        <ul class="knowledge_list">
                            <li v-for="cont in custContents" :key="cont.keyId">
                                <a href="JavaScript:" @click="showDetailInfo($event, cont)">
                                    <em v-if="cont.iconType" :class="getIconClass(cont.iconType)">{{cont.iconType}}</em>
                                    <em v-if="cont.IMPORTANCE_YN == 'Y'" class="textcolor_important">[{{$t('FIELD.GLOBAL.IMPORTANT')}}]</em>
                                    <em v-else-if="cont.MUST_READ_YN == 'Y'" class="textcolor_must">[{{$t('FIELD.GLOBAL.MUSTREAD')}}]</em>
                                    <em v-html="cont.subject"></em>
                                    <em class="info_modifi">({{cont.corpName}}, {{cont.regDate}})</em>
                                </a>
                                <span class="icon_item">
                                    <a href="JavaScript:" class="ico_favorite" :class="{off: !cont.isFavorite}" @click="addFavorite($event, cont, 'F')"> <!-- Favorite -->
                                        <span class="tooltip2">{{$t('MESSAGE.GLOBAL.ADD.FAVOR')}}</span>
                                        <span class="sr_only">{{$t('BUTTON.FAST.FAVORITE')}}</span>
                                    </a>
                                    <a href="JavaScript:" class="ico_like" :class="{off: !cont.isLike}" @click="addFavorite($event, cont, 'L')"> <!-- Remommand -->
                                        <span class="tooltip2">{{$t('MESSAGE.GLOBAL.ADD.LIKE')}}</span>
                                        <span class="sr_only">{{$t('MESSAGE.GLOBAL.LIKE')}}</span>
                                    </a>
                                </span>
                                <span class="info">
                                    <em>{{cont.dispName}}</em>
                                    <em>{{cont.prodCd2}}</em>
                                    <em>{{$t('FIELD.FAST.MODEL')}} {{cont.modelNm}}</em>
                                    <em class="hit">{{$t('FIELD.FAST.HIT')}}<i>{{cont.hitCnt}}</i></em>
                                </span>

                                <!-- Tab area -->
                                <div class="view_desc">
                                    <!-- SCMS Contents 의 경우, Symptom 및 Serial 등 추가 항목 -->
                                    <table class="data_table_ty2 mb-20">
                                        <colgroup>
                                            <col width="20%">
                                            <col width="30%">
                                            <col width="20%">
                                            <col width="*">
                                        </colgroup>
                                        <tbody>
                                            <tr>
                                                <th class="text_left">{{ $t('FIELD.GLOBAL.REGISTERED.BY') }}</th>
                                                <td>
                                                    <ul class="in_dotlist">{{ detail.REG_USER }} ({{ detail.REG_DT }})</ul>
                                                </td>
                                                <th class="text_left">{{ $t('FIELD.GLOBAL.MODIFY.USER') }}</th>
                                                <td>
                                                    <ul class="in_dotlist">{{ detail.MODF_USER }} ({{ detail.MODF_DT }})</ul>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th class="text_left">{{ $t('FIELD.GLOBAL.SYMPTOM') }}</th>
                                                <td>
                                                    <ul class="in_dotlist" v-if="symptomList.length === 0">
                                                        <li>&nbsp;</li>
                                                    </ul>
                                                    <ul class="in_dotlist" v-else v-for="symptom in symptomList">
                                                        <li>{{ symptom.NAME }}</li>
                                                    </ul>
                                                </td>
                                                <!-- TODO Manufacture date ? -->
                                                <th class="text_left">{{ $t('FIELD.KNOWLEDGE.MANUFACTURE') }}</th>
                                                <td>
                                                    <ul class="in_dotlist" v-if="serialList.length === 0">
                                                        <li>&nbsp;</li>
                                                    </ul>
                                                    <ul class="in_dotlist" v-else v-for="serial in serialList">
                                                        <li>{{ serial.SERIAL_S }} ~ {{ serial.SERIAL_E }}</li>
                                                    </ul>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th class="text_left">{{ $t('FIELD.KNOWLEDGE.GUIDETYPE') }}</th>
                                                <td>{{ getGuideTypeName }}</td>
                                                <th class="text_left">{{ $t('FIELD.KNOWLEDGE.DEFECTTYPE') }}</th>
                                                <td>{{ getDefectTypeName }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <!-- //200420수정 E -->

                                    <div class="tab_wrap">
                                        <ul class="tab_menu_02 tab_menus">
                                            <li class="on" @click="changeTab($event, cont)"><a href="javascript:">{{ $t('FIELD.GLOBAL.DESCRIPTION') }}</a></li>
                                            <li @click="changeTab($event, cont)"><a href="javascript:">{{ $t('FIELD.GLOBAL.MODEL.LIST') }}</a></li>
                                            <li @click="changeTab($event, cont)"><a href="javascript:">{{ $t('FIELD.KNOWLEDGE.PARTSLISTS') }}</a></li>
                                            <li @click="changeTab($event, cont)"><a href="javascript:">{{ $t('FIELD.KNOWLEDGE.VERHISTORY') }}</a></li>
                                        </ul>
                                        <div class="tab_contents">
                                            <div class="tab_cont" v-html="KNOWLEDGE_DESC" />
                                            <div v-if="resultCount < 999" class="grid_total">{{$t('TITLE.TOTAL.COUNT')}} : <em>{{ resultCount | numberFormat }}</em></div>
                                            <div class="tab_cont">
                                                <toast-grid
                                                    :gridId="modelGridId + cont.keyId"
                                                    :ref="modelGridId + cont.keyId"
                                                    :data="modelList"
                                                    :columns="modelColumns"
                                                    :options="options"
                                                    :pageOptions="pageOptions"
                                                    :isTotalCount="false"
                                                />
                                            </div>
                                            <div class="tab_cont">
                                                <toast-grid
                                                    :gridId="partsGridId + cont.keyId"
                                                    :ref="partsGridId + cont.keyId"
                                                    :data="partsList"
                                                    :columns="partsColumns"
                                                    :options="options"
                                                    :pageOptions="pageOptions"
                                                    :isTotalCount="false"
                                                />
                                            </div>
                                            <div class="tab_cont">
                                                <!-- Version Tab -->
                                                <table class="data_table">
                                                    <colgroup>
                                                        <col align="center" width="20%">
                                                        <col align="center" width="30%" class="pc_only">
                                                        <col width="25%" class="pc_only">
                                                        <col align="center" width="*">
                                                    </colgroup>
                                                    <thead>
                                                        <tr>
                                                            <th align="center"><b>{{ $t('FIELD.GLOBAL.VERSION') }}</b></th>
                                                            <th align="center" class="pc_only"><b>{{ $t('FIELD.GLOBAL.DATE') }}</b></th>
                                                            <th align="center" class="pc_only"><b>{{ $t('FIELD.GLOBAL.EDITOR') }}</b></th>
                                                            <th align="center"><b>{{ $t('FIELD.GLOBAL.DETAILS') }}</b></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody class="text_center">
                                                        <tr v-for="(version) in versionList" :key="version.VERSION_NO">
                                                            <td>Ver.{{ version.VERSION_NO }}</td>
                                                            <td class="pc_only">{{ version.MODF_DT }}</td>
                                                            <td class="pc_only">{{ version.MODF_USER }}</td>
                                                            <td class="text_left">
                                                                {{ version.MODF_REASON }}
                                                            <!--
                                                                <a  v-if="idx > 0"
                                                                    href="javascript:"
                                                                    class="txt_link"
                                                                    @click="seeDetailPop(version.KNOWLEDGE_ID, version.VERSION_NO)"
                                                                >
                                                                    {{ $t('FIELD.KNOWLEDGE.SEE.DETAILS') }}
                                                                </a> -->
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Attachment -->
                                    <innorix-download
                                        v-if="contAttaches && contAttaches.length > 0 && cont.active == cont.keyId"
                                        :uploadId="uploadId + cont.keyId"
                                        :serviceType="serviceType"
                                        :attachList="contAttaches"
                                        :fixWidth="irxWidth"
                                    />
                                    <!-- 200629수정 S -->
                                    <dl class="attachment_link" v-if="contAttaches.length > 0">
                                        <dt><a href="javascript:" class="txt_link" @click="toggleLink($event)">{{$t('MESSAGE.GLOBAL.TROUBLE.DOWN')}}</a></dt>
                                        <dd>
                                            <ul>
                                                <li v-for="file in contAttaches" :key="file.ENC_ATTCH_FILE_SEQ + file.ENC_TOKEN">
                                                    <a href="javascript:" @click="getDownloadUrl(file.ENC_ATTCH_FILE_SEQ, file.ENC_TOKEN)" class="txt_link">
                                                        <span class="ico_attach"></span> {{ file.FILE_NM }}
                                                    </a>
                                                </li>
                                            </ul>
                                        </dd>
                                    </dl>
                                    <!-- //Attachment -->
                                    <div class="btn_wrap text_center mt-40 pc_only"><!-- 200507수정(class 추가) -->
                                        <a href="JavaScript:" class="btn_white_ico" title="" @click="btnPrint(detail.KNOWLEDGE_ID)"><em class="ico_printer on"></em>Print</a>
                                    </div>
                                </div> <!-- End of Tab -->
                            </li>
                        </ul>
                        <div v-if="custTotalCount > 0" class="btn_wrap">
                            <a href="JavaScript:" class="btn_laodmore" @click="loadMoreCont(40, custTotalCount)">{{custMoreMsg}}
                                <em v-if="custTotalCount > 0">(<i>{{custContents.length}}</i>/{{custTotalCount}})</em>
                            </a>
                        </div>
                        <ul v-if="custTotalCount == 0" class="nodata_list">
                            <li>
                                <span>{{$t('MESSAGE.GLOBAL.NO.DATA')}}</span>
                            </li>
                        </ul>
                    </div>
                </section><!-- 3. Customer -->

                <!-- 7. Samsung.com (2020.06.24) 추가 -->
                <section data-type="customer"  :class="{active: toggle7}"><!-- 활성화시 active 클래스 -->
                    <div class="result_title samsung_title">
                        <div class="sort_wrap">
                            <a href="JavaScript:" v-for="nation in dotcomNations" :key="nation.SITE_CD"
                                @click="reloadSamsungDotcom($event, nation.SITE_CD)">{{nation.SITE_NM}} ({{nation.SITE_CD}})</a>
                        </div>
                        <em @click="toggle7 = !toggle7">Samsung.com {{$t('TITLE.LEFT.MENU.SUPPORT')}}</em>
                    </div>
                    <div class="result_con">
                        <div class="loader_box srch_dotcom" style="display:none">
                            <div class="loader"><span class="sr_only">Loading...</span></div>
                        </div>
                        <ul class="knowledge_list">
                            <li v-for="cont in dtcmContents" :key="cont.familyRecord">
                                <a :href="cont.linkUrl" target="_blank">[{{cont.siteType}}] {{cont.scTitle}}<span class="ico_link"><span class="sr_only">new window</span></span></a>
                                <span class="info">
                                    <em class="info_category"><a :href="cont.linkUrl" target="_blank" class="textcolor_must">{{cont.linkUrl}}</a></em>
                                </span>
                            </li>
                        </ul>
                        <div v-if="dtcmTotalCount > 0" class="btn_wrap">
                            <a href="JavaScript:" class="btn_laodmore" @click="getSamsungDotCom(dtcmPage)">{{dtcmMoreMsg}}
                                <em v-if="dtcmTotalCount > 0">(<i>{{dtcmContents.length}}</i>/{{dtcmTotalCount}})</em>
                            </a>
                        </div>
                        <ul v-if="dtcmTotalCount == 0" class="nodata_list">
                            <li>
                                <span>{{$t('MESSAGE.GLOBAL.NO.DATA')}}</span>
                            </li>
                        </ul>
                    </div>
                </section>

                <!-- 4. SVC Partner -->
                <section data-type="qna" :class="{active: toggle4}"><!-- 활성화시 active 클래스 -->
                    <div class="result_title">
                        <em @click="toggle4 = !toggle4">{{$t('FIELD.GLOBAL.SVCPARTNER')}}</em>
                    </div>
                    <div v-if="toggle4" class="result_con">
                        <div class="loader_box srch_engine" style="display:none">
                            <div class="loader"><span class="sr_only">Loading...</span></div>
                        </div>
                        <ul class="knowledge_list">
                            <li v-for="cont in svcpContents" :key="cont.keyId">
                                <a href="JavaScript:" @click="showDetailInfo($event, cont)">
                                    <em v-if="cont.iconType" :class="getIconClass(cont.iconType)">{{cont.iconType}}</em>
                                    <em v-if="cont.IMPORTANCE_YN == 'Y'" class="textcolor_important">[{{$t('FIELD.GLOBAL.IMPORTANT')}}]</em>
                                    <em v-else-if="cont.MUST_READ_YN == 'Y'" class="textcolor_must">[{{$t('FIELD.GLOBAL.MUSTREAD')}}]</em>
                                    <em v-html="cont.subject"></em>
                                    <em class="info_modifi">({{cont.corpName}}, {{cont.regDate}})</em>
                                </a>
                                <span class="icon_item">
                                    <a href="JavaScript:" class="ico_favorite" :class="{off: !cont.isFavorite}" @click="addFavorite($event, cont, 'F')"> <!-- Favorite -->
                                        <span class="tooltip2">{{$t('MESSAGE.GLOBAL.ADD.FAVOR')}}</span>
                                        <span class="sr_only">{{$t('BUTTON.FAST.FAVORITE')}}</span>
                                    </a>
                                    <a href="JavaScript:" class="ico_like" :class="{off: !cont.isLike}" @click="addFavorite($event, cont, 'L')"> <!-- Remommand -->
                                        <span class="tooltip2">{{$t('MESSAGE.GLOBAL.ADD.LIKE')}}</span>
                                        <span class="sr_only">{{$t('MESSAGE.GLOBAL.LIKE')}}</span>
                                    </a>
                                </span>
                                <span class="info">
                                    <em>{{cont.dispName}}</em>
                                    <em>{{cont.prodCd2}}</em>
                                    <em>{{$t('FIELD.FAST.MODEL')}} {{cont.modelNm}}</em>
                                    <em class="hit">{{$t('FIELD.FAST.HIT')}}<i>{{cont.hitCnt}}</i></em>
                                </span>

                                <!-- Tab area -->
                                <div class="view_desc">
                                    <!-- SCMS Contents 의 경우, Symptom 및 Serial 등 추가 항목 -->
                                    <table class="data_table_ty2 mb-20">
                                        <colgroup>
                                            <col width="20%">
                                            <col width="30%">
                                            <col width="20%">
                                            <col width="*">
                                        </colgroup>
                                        <tbody>
                                            <tr>
                                                <th class="text_left">{{ $t('FIELD.GLOBAL.REGISTERED.BY') }}</th>
                                                <td>
                                                    <ul class="in_dotlist">{{ detail.REG_USER }} ({{ detail.REG_DT }})</ul>
                                                </td>
                                                <th class="text_left">{{ $t('FIELD.GLOBAL.MODIFY.USER') }}</th>
                                                <td>
                                                    <ul class="in_dotlist">{{ detail.MODF_USER }} ({{ detail.MODF_DT }})</ul>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th class="text_left">{{ $t('FIELD.GLOBAL.SYMPTOM') }}</th>
                                                <td>
                                                    <ul class="in_dotlist" v-if="symptomList.length === 0">
                                                        <li>&nbsp;</li>
                                                    </ul>
                                                    <ul class="in_dotlist" v-else v-for="symptom in symptomList">
                                                        <li>{{ symptom.NAME }}</li>
                                                    </ul>
                                                </td>
                                                <!-- TODO Manufacture date ? -->
                                                <th class="text_left">{{ $t('FIELD.KNOWLEDGE.MANUFACTURE') }}</th>
                                                <td>
                                                    <ul class="in_dotlist" v-if="serialList.length === 0">
                                                        <li>&nbsp;</li>
                                                    </ul>
                                                    <ul class="in_dotlist" v-else v-for="serial in serialList">
                                                        <li>{{ serial.SERIAL_S }} ~ {{ serial.SERIAL_E }}</li>
                                                    </ul>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th class="text_left">{{ $t('FIELD.KNOWLEDGE.GUIDETYPE') }}</th>
                                                <td>{{ getGuideTypeName }}</td>
                                                <th class="text_left">{{ $t('FIELD.KNOWLEDGE.DEFECTTYPE') }}</th>
                                                <td>{{ getDefectTypeName }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <!-- //200420수정 E -->

                                    <div class="tab_wrap">
                                        <ul class="tab_menu_02 tab_menus">
                                            <li class="on" @click="changeTab($event, cont)"><a href="javascript:">{{ $t('FIELD.GLOBAL.DESCRIPTION') }}</a></li>
                                            <li @click="changeTab($event, cont)"><a href="javascript:">{{ $t('FIELD.GLOBAL.MODEL.LIST') }}</a></li>
                                            <li @click="changeTab($event, cont)"><a href="javascript:">{{ $t('FIELD.KNOWLEDGE.PARTSLISTS') }}</a></li>
                                            <li @click="changeTab($event, cont)"><a href="javascript:">{{ $t('FIELD.KNOWLEDGE.VERHISTORY') }}</a></li>
                                        </ul>
                                        <div class="tab_contents">
                                            <div class="tab_cont" v-html="KNOWLEDGE_DESC" />
                                            <div v-if="resultCount < 999" class="grid_total">{{$t('TITLE.TOTAL.COUNT')}} : <em>{{ resultCount | numberFormat }}</em></div>
                                            <div class="tab_cont">
                                                <toast-grid
                                                    :gridId="modelGridId + cont.keyId"
                                                    :ref="modelGridId + cont.keyId"
                                                    :data="modelList"
                                                    :columns="modelColumns"
                                                    :options="options"
                                                    :pageOptions="pageOptions"
                                                    :isTotalCount="false"

                                                />
                                            </div>
                                            <div class="tab_cont">
                                                <toast-grid
                                                    :gridId="partsGridId + cont.keyId"
                                                    :ref="partsGridId + cont.keyId"
                                                    :data="partsList"
                                                    :columns="partsColumns"
                                                    :options="options"
                                                    :pageOptions="pageOptions"
                                                    :isTotalCount="false"
                                                />
                                            </div>
                                            <div class="tab_cont">
                                                <!-- Version Tab -->
                                                <table class="data_table">
                                                    <colgroup>
                                                        <col align="center" width="20%">
                                                        <col align="center" width="30%" class="pc_only">
                                                        <col width="25%" class="pc_only">
                                                        <col align="center" width="*">
                                                    </colgroup>
                                                    <thead>
                                                        <tr>
                                                            <th align="center"><b>{{ $t('FIELD.GLOBAL.VERSION') }}</b></th>
                                                            <th align="center" class="pc_only"><b>{{ $t('FIELD.GLOBAL.DATE') }}</b></th>
                                                            <th align="center" class="pc_only"><b>{{ $t('FIELD.GLOBAL.EDITOR') }}</b></th>
                                                            <th align="center"><b>{{ $t('FIELD.GLOBAL.DETAILS') }}</b></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody class="text_center">
                                                        <tr v-for="(version) in versionList" :key="version.VERSION_NO">
                                                            <td>Ver.{{ version.VERSION_NO }}</td>
                                                            <td class="pc_only">{{ version.MODF_DT }}</td>
                                                            <td class="pc_only">{{ version.MODF_USER }}</td>
                                                            <td class="text_left">
                                                                {{ version.MODF_REASON }}
                                                             <!--
                                                                <a  v-if="idx > 0"
                                                                    href="javascript:"
                                                                    class="txt_link"
                                                                    @click="seeDetailPop(version.KNOWLEDGE_ID, version.VERSION_NO)"
                                                                >
                                                                    {{ $t('FIELD.KNOWLEDGE.SEE.DETAILS') }}
                                                                </a> -->
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Attachment -->
                                    <innorix-download
                                        v-if="contAttaches && contAttaches.length > 0 && cont.active == cont.keyId"
                                        :uploadId="uploadId + cont.keyId"
                                        :serviceType="serviceType"
                                        :attachList="contAttaches"
                                        :fixWidth="irxWidth"
                                    />
                                    <!-- 200629수정 S -->
                                    <dl class="attachment_link" v-if="contAttaches.length > 0">
                                        <dt><a href="javascript:" class="txt_link" @click="toggleLink($event)">{{$t('MESSAGE.GLOBAL.TROUBLE.DOWN')}}</a></dt>
                                        <dd>
                                            <ul>
                                                <li v-for="file in contAttaches" :key="file.ENC_ATTCH_FILE_SEQ + file.ENC_TOKEN">
                                                    <a href="javascript:" @click="getDownloadUrl(file.ENC_ATTCH_FILE_SEQ, file.ENC_TOKEN)" class="txt_link">
                                                        <span class="ico_attach"></span> {{ file.FILE_NM }}
                                                    </a>
                                                </li>
                                            </ul>
                                        </dd>
                                    </dl>

                                    <!-- //Attachment -->
                                    <div class="btn_wrap text_center mt-40 pc_only"><!-- 200507수정(class 추가) -->
                                        <a href="JavaScript:" class="btn_white_ico" title="" @click="btnPrint(detail.KNOWLEDGE_ID)"><em class="ico_printer on"></em>Print</a>
                                    </div>
                                </div> <!-- End of Tab -->
                            </li>
                        </ul>
                        <div v-if="svcpTotalCount > 0" class="btn_wrap">
                            <a href="JavaScript:" class="btn_laodmore" @click="loadMoreCont(50, svcpTotalCount)">{{svcpMoreMsg}}
                                <em v-if="svcpTotalCount > 0">(<i>{{svcpContents.length}}</i>/{{svcpTotalCount}})</em>
                            </a>
                        </div>
                        <ul v-if="svcpTotalCount == 0" class="nodata_list">
                            <li>
                                <span>{{$t('MESSAGE.GLOBAL.NO.DATA')}}</span>
                            </li>
                        </ul>
                    </div>
                </section><!-- 4. SVC Partner -->


                <!-- 5. Subsidiary -->
                <section data-type="qna"  :class="{active: toggle5}"><!-- 활성화시 active 클래스 -->
                    <div class="result_title">
                        <em @click="toggle5 = !toggle5">{{$t('FIELD.GLOBAL.SUBSIDIARY')}}</em>
                    </div>
                    <div v-if="toggle5" class="result_con">
                        <div class="loader_box srch_engine" style="display:none">
                            <div class="loader"><span class="sr_only">Loading...</span></div>
                        </div>
                        <ul class="knowledge_list">
                            <li v-for="cont in subsContents" :key="cont.keyId">
                                <a href="JavaScript:" @click="showDetailInfo($event, cont)">
                                    <em v-if="cont.iconType" :class="getIconClass(cont.iconType)">{{cont.iconType}}</em>
                                    <em v-if="cont.IMPORTANCE_YN == 'Y'" class="textcolor_important">[{{$t('FIELD.GLOBAL.IMPORTANT')}}]</em>
                                    <em v-else-if="cont.MUST_READ_YN == 'Y'" class="textcolor_must">[{{$t('FIELD.GLOBAL.MUSTREAD')}}]</em>
                                    <em v-html="cont.subject"></em>
                                    <em class="info_modifi">({{cont.corpName}}, {{cont.regDate}})</em>
                                </a>
                                <span class="icon_item">
                                    <a href="JavaScript:" class="ico_favorite" :class="{off: !cont.isFavorite}" @click="addFavorite($event, cont, 'F')"> <!-- Favorite -->
                                        <span class="tooltip2">{{$t('MESSAGE.GLOBAL.ADD.FAVOR')}}</span>
                                        <span class="sr_only">{{$t('BUTTON.FAST.FAVORITE')}}</span>
                                    </a>
                                    <a href="JavaScript:" class="ico_like" :class="{off: !cont.isLike}" @click="addFavorite($event, cont, 'L')"> <!-- Remommand -->
                                        <span class="tooltip2">{{$t('MESSAGE.GLOBAL.ADD.LIKE')}}</span>
                                        <span class="sr_only">{{$t('MESSAGE.GLOBAL.LIKE')}}</span>
                                    </a>
                                </span>
                                <span class="info">
                                    <em>{{cont.dispName}}</em>
                                    <em>{{cont.prodCd2}}</em>
                                    <em>{{$t('FIELD.FAST.MODEL')}} {{cont.modelNm}}</em>
                                    <em class="hit">{{$t('FIELD.FAST.HIT')}}<i>{{cont.hitCnt}}</i></em>
                                </span>

                                <!-- Tab area -->
                                <div class="view_desc">
                                    <!-- SCMS Contents 의 경우, Symptom 및 Serial 등 추가 항목 -->
                                    <table class="data_table_ty2 mb-20">
                                        <colgroup>
                                            <col width="20%">
                                            <col width="30%">
                                            <col width="20%">
                                            <col width="*">
                                        </colgroup>
                                        <tbody>
                                            <tr>
                                                <th class="text_left">{{ $t('FIELD.GLOBAL.REGISTERED.BY') }}</th>
                                                <td>
                                                    <ul class="in_dotlist">{{ detail.REG_USER }} ({{ detail.REG_DT }})</ul>
                                                </td>
                                                <th class="text_left">{{ $t('FIELD.GLOBAL.MODIFY.USER') }}</th>
                                                <td>
                                                    <ul class="in_dotlist">{{ detail.MODF_USER }} ({{ detail.MODF_DT }})</ul>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th class="text_left">{{ $t('FIELD.GLOBAL.SYMPTOM') }}</th>
                                                <td>
                                                    <ul class="in_dotlist" v-if="symptomList.length === 0">
                                                        <li>&nbsp;</li>
                                                    </ul>
                                                    <ul class="in_dotlist" v-else v-for="symptom in symptomList">
                                                        <li>{{ symptom.NAME }}</li>
                                                    </ul>
                                                </td>
                                                <!-- TODO Manufacture date ? -->
                                                <th class="text_left">{{ $t('FIELD.KNOWLEDGE.MANUFACTURE') }}</th>
                                                <td>
                                                    <ul class="in_dotlist" v-if="serialList.length === 0">
                                                        <li>&nbsp;</li>
                                                    </ul>
                                                    <ul class="in_dotlist" v-else v-for="serial in serialList">
                                                        <li>{{ serial.SERIAL_S }} ~ {{ serial.SERIAL_E }}</li>
                                                    </ul>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th class="text_left">{{ $t('FIELD.KNOWLEDGE.GUIDETYPE') }}</th>
                                                <td>{{ getGuideTypeName }}</td>
                                                <th class="text_left">{{ $t('FIELD.KNOWLEDGE.DEFECTTYPE') }}</th>
                                                <td>{{ getDefectTypeName }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <!-- //200420수정 E -->

                                    <div class="tab_wrap">
                                        <ul class="tab_menu_02 tab_menus">
                                            <li class="on" @click="changeTab($event, cont)"><a href="javascript:">{{ $t('FIELD.GLOBAL.DESCRIPTION') }}</a></li>
                                            <li @click="changeTab($event, cont)"><a href="javascript:">{{ $t('FIELD.GLOBAL.MODEL.LIST') }}</a></li>
                                            <li @click="changeTab($event, cont)"><a href="javascript:">{{ $t('FIELD.KNOWLEDGE.PARTSLISTS') }}</a></li>
                                            <li @click="changeTab($event, cont)"><a href="javascript:">{{ $t('FIELD.KNOWLEDGE.VERHISTORY') }}</a></li>
                                        </ul>
                                        <div class="tab_contents">
                                            <div class="tab_cont" v-html="KNOWLEDGE_DESC" />
                                            <div v-if="resultCount < 999" class="grid_total">{{$t('TITLE.TOTAL.COUNT')}} : <em>{{ resultCount | numberFormat }}</em></div>
                                            <div class="tab_cont">
                                                <toast-grid
                                                    :gridId="modelGridId + cont.keyId"
                                                    :ref="modelGridId + cont.keyId"
                                                    :data="modelList"
                                                    :columns="modelColumns"
                                                    :options="options"
                                                    :pageOptions="pageOptions"
                                                    :isTotalCount="false"
                                                />
                                            </div>
                                            <div class="tab_cont">
                                                <toast-grid
                                                    :gridId="partsGridId + cont.keyId"
                                                    :ref="partsGridId + cont.keyId"
                                                    :data="partsList"
                                                    :columns="partsColumns"
                                                    :options="options"
                                                    :pageOptions="pageOptions"
                                                    :isTotalCount="false"
                                                />
                                            </div>
                                            <div class="tab_cont">
                                                <!-- Version Tab -->
                                                <table class="data_table">
                                                    <colgroup>
                                                        <col align="center" width="20%">
                                                        <col align="center" width="30%" class="pc_only">
                                                        <col width="25%" class="pc_only">
                                                        <col align="center" width="*">
                                                    </colgroup>
                                                    <thead>
                                                        <tr>
                                                            <th align="center"><b>{{ $t('FIELD.GLOBAL.VERSION') }}</b></th>
                                                            <th align="center" class="pc_only"><b>{{ $t('FIELD.GLOBAL.DATE') }}</b></th>
                                                            <th align="center" class="pc_only"><b>{{ $t('FIELD.GLOBAL.EDITOR') }}</b></th>
                                                            <th align="center"><b>{{ $t('FIELD.GLOBAL.DETAILS') }}</b></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody class="text_center">
                                                        <tr v-for="(version) in versionList" :key="version.VERSION_NO">
                                                            <td>Ver.{{ version.VERSION_NO }}</td>
                                                            <td class="pc_only">{{ version.MODF_DT }}</td>
                                                            <td class="pc_only">{{ version.MODF_USER }}</td>
                                                            <td class="text_left">
                                                                {{ version.MODF_REASON }}
                                                            <!--
                                                                <a  v-if="idx > 0"
                                                                    href="javascript:"
                                                                    class="txt_link"
                                                                    @click="seeDetailPop(version.KNOWLEDGE_ID, version.VERSION_NO)"
                                                                >
                                                                    {{ $t('FIELD.KNOWLEDGE.SEE.DETAILS') }}
                                                                </a>  -->
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Attachment -->
                                    <innorix-download
                                        v-if="contAttaches && contAttaches.length > 0 && cont.active == cont.keyId"
                                        :uploadId="uploadId + cont.keyId"
                                        :serviceType="serviceType"
                                        :attachList="contAttaches"
                                        :fixWidth="irxWidth"
                                    />
                                    <!-- 200629수정 S -->
                                    <dl class="attachment_link" v-if="contAttaches.length > 0">
                                        <dt><a href="javascript:" class="txt_link" @click="toggleLink($event)">{{$t('MESSAGE.GLOBAL.TROUBLE.DOWN')}}</a></dt>
                                        <dd>
                                            <ul>
                                                <li v-for="file in contAttaches" :key="file.ENC_ATTCH_FILE_SEQ + file.ENC_TOKEN">
                                                    <a href="javascript:" @click="getDownloadUrl(file.ENC_ATTCH_FILE_SEQ, file.ENC_TOKEN)" class="txt_link">
                                                        <span class="ico_attach"></span> {{ file.FILE_NM }}
                                                    </a>
                                                </li>
                                            </ul>
                                        </dd>
                                    </dl>

                                    <!-- //Attachment -->
                                    <div class="btn_wrap text_center mt-40 pc_only"><!-- 200507수정(class 추가) -->
                                        <a href="JavaScript:" class="btn_white_ico" title="" @click="btnPrint(detail.KNOWLEDGE_ID)"><em class="ico_printer on"></em>Print</a>
                                    </div>
                                </div> <!-- End of Tab -->
                            </li>
                        </ul>
                        <div v-if="subsTotalCount > 0" class="btn_wrap">
                            <a href="JavaScript:" class="btn_laodmore" @click="loadMoreCont(60, subsTotalCount)">{{subsMoreMsg}}
                                <em v-if="subsTotalCount > 0">(<i>{{subsContents.length}}</i>/{{subsTotalCount}})</em>
                            </a>
                        </div>
                        <ul v-if="subsTotalCount == 0" class="nodata_list">
                            <li>
                                <span>{{$t('MESSAGE.GLOBAL.NO.DATA')}}</span>
                            </li>
                        </ul>
                    </div>
                </section><!-- 5. Subsidiary -->


                <!-- 6. Q&A -->
                <section data-type="qna"  :class="{active: toggle6}"><!-- 활성화시 active 클래스 -->
                    <div class="result_title">
                        <em @click="toggle6 = !toggle6">{{$t('FIELD.GLOBAL.QNA')}}</em>
                    </div>
                    <div v-if="toggle6" class="result_con">
                        <div class="loader_box srch_engine" style="display:none">
                            <div class="loader"><span class="sr_only">Loading...</span></div>
                        </div>
                        <ul class="qna_result_list">
                            <li v-for="cont in qnaaContents" :key="cont.keyId">
                                <a href="JavaScript:" @click="showQnaInfo($event, cont)">
                                    <span>
                                        <em v-if="cont.iconType" :class="getIconClass(cont.iconType)">{{cont.iconType}}</em>
                                        <em v-if="cont.IMPORTANCE_YN == 'Y'" class="textcolor_important">[{{$t('FIELD.GLOBAL.IMPORTANT')}}]</em>
                                        <em v-else-if="cont.MUST_READ_YN == 'Y'" class="textcolor_must">[{{$t('FIELD.GLOBAL.MUSTREAD')}}]</em>
                                        <em v-html="cont.subject"></em>
                                    </span>
                                    <i>{{cont.regUser}} ({{cont.regDate}})</i>
                                </a>
                                <div class="conts">
                                    <div class="q_cont">
                                        <div :key="qnaInfo.questionId" v-html="stripHtml(QNA_DESCR)"></div>
                                    </div>
                                    <!-- Question Attachment -->
                                    <innorix-download
                                        v-if="QST_ATTACHES && QST_ATTACHES.length > 0 && cont.active == cont.keyId"
                                        :uploadId="uploadId + cont.keyId"
                                        :serviceType="serviceType"
                                        :attachList="QST_ATTACHES"
                                        :fixWidth="irxWidth"
                                    />
                                    <!-- 200714수정 S -->
                                    <dl class="attachment_link" v-if="QST_ATTACHES.length > 0">
                                        <dt><a href="javascript:" class="txt_link" @click="toggleLink($event)">{{$t('MESSAGE.GLOBAL.TROUBLE.DOWN')}}</a></dt>
                                        <dd>
                                            <ul>
                                                <li v-for="file in QST_ATTACHES" :key="file.ENC_ATTCH_FILE_SEQ + file.ENC_TOKEN">
                                                    <a href="javascript:" @click="getDownloadUrl(file.ENC_ATTCH_FILE_SEQ, file.ENC_TOKEN)" class="txt_link">
                                                        <span class="ico_attach"></span> {{ file.FILE_NM }}
                                                    </a>
                                                </li>
                                            </ul>
                                        </dd>
                                        <br/>
                                    </dl>

                                    <div class="a_cont" v-if="QNA_REPLY">
                                        <div class="namo_scrollbar" v-html="stripHtml(QNA_REPLY)"></div>
                                        <innorix-download
                                            v-if="ANS_ATTACHES && ANS_ATTACHES.length > 0 && cont.active == cont.keyId"
                                            :uploadId="uploadId + cont.keyId"
                                            :serviceType="serviceType"
                                            :attachList="ANS_ATTACHES"
                                            :fixWidth="irxWidth"
                                        />
                                        <!-- 200714수정 S -->
                                        <dl class="attachment_link" v-if="ANS_ATTACHES.length > 0">
                                            <dt><a href="javascript:" class="txt_link" @click="toggleLink($event)">{{$t('MESSAGE.GLOBAL.TROUBLE.DOWN')}}</a></dt>
                                            <dd>
                                                <ul>
                                                    <li v-for="file in ANS_ATTACHES" :key="file.ENC_ATTCH_FILE_SEQ + file.ENC_TOKEN">
                                                        <a href="javascript:" @click="getDownloadUrl(file.ENC_ATTCH_FILE_SEQ, file.ENC_TOKEN)" class="txt_link">
                                                            <span class="ico_attach"></span> {{ file.FILE_NM }}
                                                        </a>
                                                    </li>
                                                </ul>
                                            </dd>
                                        </dl>
                                    </div>
                                </div>
                            </li>
                        </ul>
                        <div v-if="qnaaTotalCount > 0" class="btn_wrap">
                            <a href="JavaScript:" class="btn_laodmore" @click="loadMoreCont(20, qnaaTotalCount)">{{qnaaMoreMsg}}
                                <em v-if="qnaaTotalCount > 0">(<i>{{qnaaContents.length}}</i>/{{qnaaTotalCount}})</em>
                            </a>
                        </div>
                        <ul v-if="qnaaTotalCount == 0" class="nodata_list">
                            <li>
                                <span>{{$t('MESSAGE.GLOBAL.NO.DATA')}}</span>
                            </li>
                        </ul>
                    </div>
                </section><!-- 6. Q&A -->

            </div>
        </div>
    </div>
    <!-- contents -->
</template>

<script>
import Vue              from 'vue';
import axios            from 'axios';
import qs               from 'query-string';
import _                from 'lodash';
import $                from 'jquery';
import moment           from 'moment';
import { mapGetters }   from 'vuex';
import { SDLUtil }      from '@/utils';
import { StringUtil }   from '@/utils';
import { EventBus }     from '@/utils/EventBus';
import DatePicker       from '~c/DatePicker';
import AttachFilePopup  from './AttachFilePopup';
import ToastGrid        from '~c/ToastGrid';
import InnorixDownload  from '~c/InnorixDownload';
import SearchArea       from './SearchArea';
import ContPrintPopup   from '~vb/knowledge/popup/KnowledgeContentsPrintPopup';

// Samsung.com의 nation code와 corpNo mapping
const nationMap = {
    'C310':'us', 'C330':'ca', 'C813':'co', 'C830':'ar', 'C820':'br', 'C810':'latin', 'C850':'cl', 'C390':'mx',
    'C860':'pe', 'C4L1':'hr', 'C4L0':'at', 'C4M6':'lv', 'C4B1':'nl', 'C493':'cz', 'C480':'fr', 'C460':'de',
    'C4N2':'gr', 'C490':'hu', 'C4A0':'it', 'C4F0':'se', 'C4E0':'pt', 'C4D0':'pl', 'C4B6':'ro', 'C470':'es',
    'C4L2':'ch', 'C430':'uk', 'C981':'kz_ru', 'C962':'ua', 'C941':'ru', 'C630':'cn', 'C610':'hk_en', 'C540':'sg',
    'C530':'vn', 'C560':'au', 'C570':'id', 'C565':'nz', 'C5B3':'ph', 'C6A0':'tw', 'C5F0':'my', 'C5A0':'th',
    'C550':'in', 'C712':'eg', 'C713':'il', 'C715':'pk', 'C711':	'sa', 'C770':'levant_ar', 'C780':'n_africa',
    'C750':'tr', 'C710':'ae', 'C702':'africa_en', 'C701':'africa_en', 'C720':'za', 'C290':'jp', 'C100':'sec'
};

// 검색결과 디테일에서 사용
const fetchDetail = (knowledgeId, boardId) => axios.post(
    `${SDLUtil.API_URL}/basis/knowledge/knowledgeDetail.skp`,
    qs.stringify({ KNOWLEDGE_ID: knowledgeId, BOARD_ID: boardId }),
    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
);

export default {
    name: 'SearchList',
    props: {
//        params: {}
    },
    components: {
        'base-search-area'  : SearchArea,
        'toast-grid'        : ToastGrid,
        'innorix-download'  : InnorixDownload
    },
    data() {
        return {
            isLoaded: 0,
            irxWidth: 0,
            keyword: '',
            params: {},
            startNum: 0,    // 시작순서
            pageSize: 5,    // QuickDownloads 페이지당 갯수
            serverSize: 50, // 서버 페이지당 갯수
            sortBy: 'regdate',
            relResearch: 'N',
            moreKey: '', // contcoll ID
            contName: '', // LeftSnb에서 Contente Type 클릭 시 넘기는 값
            cateName: '', // LeftSnb에서 Category Name 클릭 시 넘기는 값
            corpName: '',   // LeftSnb에서 Search within 클릭 시 넘기는 값
            siteCd: '',
            autoCompletes: [],
            recentModels: [],
            cursorIndex: -1,
            relatedSearchWords: [],
            columns: [],
            quickDownloads: [],
            selModelCd: '',
            selModels: [],
            engrContents: [],
            custContents: [],
            svcpContents: [],
            subsContents: [],
            qnaaContents: [],
            engrTotContents: [],
            custTotContents: [],
            svcpTotContents: [],
            subsTotContents: [],
            qnaaTotContents: [],
            dtcmContents: [],
            dotcomNations: [],
            naviContentsTypes: [],

            sympCode: '',
            sympDesc: '',
            sympTypeCode: '',
            isSearching: false,
            rangePicker: null,
            FR_DATE: {},
            TO_DATE: {},
            bLiked: false, // 좋아요 클릭 여부
            togFavorite: true, // 즐겨찾기 클릭 여부
            toggle1: true,
            toggle2: true,
            toggle3: true,
            toggle4: true,
            toggle5: true,
            toggle6: true,
            toggle7: true,
            clickedMenuNm: 'Refine by Engineer & LED',

            qcdnMoreMsg: SDLUtil.getMsgProp('BUTTON.SEARCH.LOAD.MORE'),
            engrMoreMsg: SDLUtil.getMsgProp('BUTTON.SEARCH.LOAD.MORE'),
            custMoreMsg: SDLUtil.getMsgProp('BUTTON.SEARCH.LOAD.MORE'),
            svcpMoreMsg: SDLUtil.getMsgProp('BUTTON.SEARCH.LOAD.MORE'),
            subsMoreMsg: SDLUtil.getMsgProp('BUTTON.SEARCH.LOAD.MORE'),
            qnaaMoreMsg: SDLUtil.getMsgProp('BUTTON.SEARCH.LOAD.MORE'),
            dtcmMoreMsg: SDLUtil.getMsgProp('BUTTON.SEARCH.LOAD.MORE'),

            qcdnPage : 1,
            engrPage : 1,
            custPage : 1,
            svcpPage : 1,
            subsPage : 1,
            qnaaPage : 1,
            dtcmPage : 1,
            qcdnAttachFiles: [],

            qcdnTotalCount: 0, // Quick Downloads 전체건수
            engrTotalCount: 0, // Engineer 전체건수
            custTotalCount: 0, // Customer 전체건수
            svcpTotalCount: 0, // SVC Partner 전체건수
            subsTotalCount: 0, // Subsidiary 전체건수
            qnaaTotalCount: 0, // Q&A 전체건수
            dtcmTotalCount: 0, // Dotcom 전체건수

            dotcomNavis: {}, // dotcom navigations

            // Detail 영역에서 사용하는 변수들..
            resultCount: 0,
            modelList: [],
            partsList: [],
            symptomList: [],
            serialList: [],
            detail: {},
            qnaInfo: {},
            KNOWLEDGE_DESC: '', // Knowledge Description
            QNA_DESCR: '',      // Q&A Description
            QNA_REPLY: '',      // Q&A Replay
            QST_ATTACHES: [],   // Q&A Question Attached Files
            ANS_ATTACHES: [],   // Q&A Answer Attached Files
            contAttaches: [],   // Others Attached Files
            versionList: [],
            isScmsContent: false,

            modelGridId: 'mdlGrid_',
            modelColumns: [
//                { header: SDLUtil.getMsgProp('FIELD.GLOBAL.SUBSIDIARY'), name: 'NMCOMPANY', align: 'center', width: 160, resizable: true, sortable: true },
                { header: SDLUtil.getMsgProp('FIELD.GLOBAL.MODEL.CODE'), name: 'CDMODEL', align: 'center', resizable: true, sortable: true,
                            filter: { type: 'text', showApplyBtn: true, showClearBtn: true, state: { code: 'contain'} } },
                { header: SDLUtil.getMsgProp('FIELD.GLOBAL.MODEL.NAME'), name: 'NMMODEL', align: 'center', resizable: true, sortable: true },
                { header: SDLUtil.getMsgProp('FIELD.GLOBAL.MARKETINGNAME'), name: 'MAKETNM', align: 'center', resizable: true, sortable: true },
                { header: 'CDCOMPANY', name: 'CDCOMPANY', hidden: true },
                { header: 'CDGBM', name: 'CDGBM', hidden: true }
            ],
            partsGridId: 'ptsGrid_',
            partsColumns: [
                /* 2020.04.06 Parts Name 컬럼 삭제 */
                { header: SDLUtil.getMsgProp('FIELD.GLOBAL.PARTS.CODE'), name: 'PARTS_CODE', align: 'center', resizable: true, sortable: true },
                { header: SDLUtil.getMsgProp('FIELD.GLOBAL.PARTS.TYPE'), name: 'PARTS_TYPE', align: 'center', resizable: true, sortable: true }
            ],

            options: {
                scrollY: true,
                minBodyHeight: 80,
                rowHeight: 25,
                bodyHeight: 265
            },
            pageOptions: {
                useClient: true,
                perPage: 10
            },

            uploadId: 'download_',
            serviceType: 'common'
        };
    },
    computed: {
        ...mapGetters({
            loginNo: 'getLoginNo',
            userCorpCd: 'getCorpCd'
        }),
        getLoginNo()            { return this.loginNo || ''; },
        getUserCorpCd()         { return this.userCorpCd || ''; },
        getGuideTypeName() {
            let guideType = this.detail.GUIDE_TYPE || '',
                guideTypeName = {"H":"H/W", "S":"S/W", "M":"Mechanical", "A":"Accessory", "I":"Info Sharing", "E":"Others"};

            if (!SDLUtil.isNull(guideType)) {
                return guideTypeName[guideType];
            } else {
                return  '-';
            }
        },
        getDefectTypeName() {
            let defectType = this.detail.DEFECT_TYPE || '',
                defectTypeName = { "M":"Common", "C":"Call", "R":"Repair" };

            if (!SDLUtil.isNull(defectType)) {
                return defectTypeName[defectType];
            } else {
                return  '-';
            }
        }
    },
    methods: {
        initReset() {
            this.dtcmPage    = 1;
            this.dotcomNavis = null;
            this.qcdnTotalCount = -1;
            this.engrTotalCount = -1;
            this.custTotalCount = -1;
            this.svcpTotalCount = -1;
            this.subsTotalCount = -1;
            this.qnaaTotalCount = -1;
            this.dtcmTotalCount = -1;
            this.relatedSearchWords = [];
            this.quickDownloads  = [];
            this.engrTotContents = [];
            this.custTotContents = [];
            this.svcpTotContents = [];
            this.subsTotContents = [];
            this.qnaaTotContents = [];
            this.engrContents = [];
            this.custContents = [];
            this.svcpContents = [];
            this.subsContents = [];
            this.qnaaContents = [];
            this.dtcmContents = [];
        },
        async execServer(url, param, aftMode) {
            return await axios
                .post(url,
                    qs.stringify(param), {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    params: { searchInfo: 'set' },
                })
                .then(resp => {
                    let msg = '';
                    if (aftMode == 1) {
//                        this.loadRecentModels();
//                        this.$refs.kword.focus(); // 자동완성
                    } else if (aftMode == 2) { // favorite save
                        msg = 'MESSAGE.GLOBAL.ADDED.FAVOR';
                    } else if (aftMode == 3) { // favorite delete
                        msg = 'MESSAGE.GLOBAL.REMOVEFAVORITE';
                          } else if (aftMode == 4) { // like save
                        msg = 'MESSAGE.GLOBAL.RECOMMEND.IT';
                        this.bLiked = true;
                    }

                    if (aftMode > 1) {
                        Vue.toasted.show(
                            SDLUtil.getMsgProp(msg), {
                                theme: "toasted-primary",
                                position: "top-center",
                                duration : 3000
                            }
                        );
                    }
                })
                .catch(err => {
//                    Vue.$log.error(err);
                    console.log('Err.execServer ==> ', err);
                    SDLUtil.errorAlert(err);
                });
        },
        // 헤더 컬럼 세팅
        setColumnHeader(data, page) {
            this.columns = [];
            if (!data.header) {
                this.quickDownloads = [];
                return;
            }
           let explodedList = data.explodedResult;
            if (data.contentModels.rowData && data.contentModels.rowData.length > 0) {
            data.header.rowData.forEach(head => {
                let headId = 'CNT' + (head.CONTENT_VIEW_ORDER - 1);
                if (head.CONTENT_VIEW_ORDER == 999) {
                    headId = 'CNT_EXPVP';
                }
                // 3D Exploded View disabled
                // if (head.CONTENT_VIEW_ORDER == 1000) {
                //     headId = 'CNT_3DEXPVW';
                // }
                let width = 90 + (head.MENU_NM.length * 2);
                let cols = {
                    headerId: headId
                  , boardId : head.BOARD_ID
                  , headerNm: head.MENU_NM
                };
                this.columns.push(cols);
            });
            }

            data.contentModels.rowData.forEach(data => {
                let newArr = [];

                this.columns.forEach((col, index) => {
                    let val = eval('data.CNT' + index);
                    if (col.headerId == 'CNT_EXPVP') {
                        val = 'WEB: ' + eval('data.CNT' + index) + ' / PDF: ' + data.CNT_EXPVP;
                    }
                    // 3D Exploded View disabled
                    // else if (col.headerId == 'CNT_3DEXPVW') {
                    //     val = 'WEB: ' + eval('data.CNT' + index) + ' / PDF: ' + data.CNT_3DEXPVP;
                    // }
                    let colSum = {ID: 'CNT' + index, nIndex: index, cntSum: val, headId: col.headerId, headNm: col.headerNm};
                    newArr.push(colSum);
                });
                data.subValues = newArr;
            });

            if (page == 1) {
                this.quickDownloads = data.contentModels.rowData;
            } else { // > 1
                data.contentModels.rowData.forEach(adata => {
                    this.quickDownloads.push(adata);
                });
            }
            if (this.quickDownloads && this.quickDownloads.length > 0) {
                this.selModelCd = this.quickDownloads[0].BMODEL_ID;
                this.selModels = this.quickDownloads[0].subValues;
            }

        },
        // More, Total, No data 버튼 설정
        setButtonMsg(contKey, totCount, contents) {
            let msg = '';
            if (totCount == 0) {
                msg = SDLUtil.getMsgProp('MESSAGE.GLOBAL.NO.DATA');
            } else if (totCount > 0 && totCount <= this.pageSize) {
                msg = SDLUtil.getMsgProp('FIELD.GLOBAL.TOTAL');
            } else if (totCount > 0 && totCount == contents.length) {
                msg = SDLUtil.getMsgProp('FIELD.GLOBAL.TOTAL');
            } else if (totCount > 0 && contents.length < totCount) {
                msg = SDLUtil.getMsgProp('BUTTON.SEARCH.LOAD.MORE');
            }

            if (contKey == 30) {
                this.engrMoreMsg = msg;
            } else if (contKey == 40) {
                this.custMoreMsg = msg;
            } else if (contKey == 50) {
                this.svcpMoreMsg = msg;
            } else if (contKey == 60) {
                this.subsMoreMsg = msg;
            } else if (contKey == 20) {
                this.qnaaMoreMsg = msg;
            } else if (contKey == 70) {
                this.dtcmMoreMsg = msg;
            }
        },
        setContentTypeNavi() {
            // Left Snb - 좌측 상단 [Contents Type]
            // QNA가 가장 아래로 오게 수정
            let conts = [], qna = null;
            this.naviContentsTypes.forEach(elm => {
                if (elm.naviName == 'QNA') qna = elm;
                else                 conts.push(elm);
            });

            SDLUtil.sortArray(conts, 'naviCode');
            if (qna) conts.push(qna);

            let delay = (this.dotcomNavis) ? 100 : 800;
            setTimeout(() => {
                if (this.dotcomNavis) conts.push(this.dotcomNavis);
                const param2 = {params: this.getSearchParam(), subsList: conts};
                EventBus.$emit('search-contents-reload', param2);
            }, delay);
        },
        getDataFromServer(mode, initMode) {
            let url = '';
            if (mode == 1) {
                if (this.quickDownloads.length == 0) $('.quick_downs').show();
                url = `${SDLUtil.API_URL}/basis/search/searchContentsByModel.skp`;
            } else if (mode == 2) {
//                $('.srch_relword').show();
                $('.srch_engine').show();
                url = `${SDLUtil.API_URL}/basis/search/getSearchEngineData.skp`;
            }
            const param = this.getSearchParam();
            param.initMode = (initMode) ? 'Y' : '';
            return axios
                .post(url, qs.stringify(param), {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    params: { searchInfo: 'set' }
                })
                .then(resp => {
                    if (mode == 1) { // Local DB
                        this.qcdnTotalCount = resp.data.rowTotalCount || 0;
                        if (resp.data.contentModels) this.qcdnLoadCount += resp.data.contentModels.rowData.length;
                        if (this.qcdnLoadCount == this.qcdnTotalCount) {
                            this.qcdnMoreMsg = SDLUtil.getMsgProp('FIELD.GLOBAL.TOTAL');
                        } else if (this.qcdnLoadCount < this.qcdnTotalCount) {
                            this.qcdnMoreMsg = SDLUtil.getMsgProp('BUTTON.SEARCH.LOAD.MORE');
                        }
                        this.setColumnHeader(resp.data, this.qcdnPage);
                        $('.quick_downs').hide();
                        SDLUtil.showLoadingBar(false);
                    } else if (mode == 2) { // Search Engine
                        // console.log('Engine.resp.data ===> ', resp.data);
/*                        if (resp.data.retCode == 1017) {
                            SDLUtil.alert('Sorry for the result being too late.<br>Enter more than 5 bytes of model code for a more effective search');
                            SDLUtil.showLoadingBar(false);
                            return;
                        }
*/
                        // 연관검색어
                        this.relatedSearchWords = resp.data.relatedSearchWords || [];
//                        $('.srch_relword').hide();

                        // 전체건수 & 컨텐츠 부분...
                        this.engrTotalCount = resp.data.engrCnt;
                        this.custTotalCount = resp.data.custCnt;
                        this.svcpTotalCount = resp.data.svcpCnt;
                        this.subsTotalCount = resp.data.subsCnt;
                        this.qnaaTotalCount = resp.data.qnaaCnt;
                        if (resp.data.resultContents) {
                            this.engrTotContents = resp.data.resultContents.engrConts || [];
                            this.custTotContents = resp.data.resultContents.custConts || [];
                            this.svcpTotContents = resp.data.resultContents.svcpConts || [];
                            this.subsTotContents = resp.data.resultContents.subsConts || [];
                            this.qnaaTotContents = resp.data.resultContents.qnaaConts || [];
                        }

                        // 초기 5개씩만 집어 넣음.
                        this.engrContents = [];
                        this.engrTotContents.forEach((elm, index) => {
                            if (index < this.pageSize) this.engrContents.push(elm);
                            else return;
                        });
                        this.custContents = [];
                        this.custTotContents.forEach((elm, index) => {
                            if (index < this.pageSize) this.custContents.push(elm);
                        });
                        this.svcpContents = [];
                        this.svcpTotContents.forEach((elm, index) => {
                            if (index < this.pageSize) this.svcpContents.push(elm);
                        });
                        this.subsContents = [];
                        this.subsTotContents.forEach((elm, index) => {
                            if (index < this.pageSize) this.subsContents.push(elm);
                        });
                        this.qnaaContents = [];
                        this.qnaaTotContents.forEach((elm, index) => {
                            if (index < this.pageSize) this.qnaaContents.push(elm);
                        });

                        this.setButtonMsg(30, this.engrTotalCount, this.engrContents);
                        this.setButtonMsg(40, this.custTotalCount, this.custContents);
                        this.setButtonMsg(50, this.svcpTotalCount, this.svcpContents);
                        this.setButtonMsg(60, this.subsTotalCount, this.subsContents);
                        this.setButtonMsg(20, this.qnaaTotalCount, this.qnaaContents);

                        // Left Snb - 좌측 상단 [Contents Type]
                        // QNA가 가장 아래로 오게 수정
                        let conts = [], qna = null;
                        this.naviContentsTypes = resp.data.naviContentsTypes;
                        if (this.naviContentsTypes) {
                            this.setContentTypeNavi();
                        }

                        // 좌측 중간 [Product Category]
                        const param3 = {params: this.getSearchParam(), subsList: resp.data.naviProdCategories};
                        EventBus.$emit('search-category-reload', param3);

                        if (initMode) {
                            // 좌측 아래 [Search wthin]
                            const param4 = {params: this.getSearchParam(), subsList: resp.data.naviSearchWithins};
                            EventBus.$emit('search-within-reload', param4);
                        }
                        // 최근검색어 다시 로드
                        EventBus.$emit('recent-words-reload');

                        $('.srch_engine').hide();
                        SDLUtil.showLoadingBar(false);
                    }
                    this.isSearching = false;
                })
                .catch(err => {
                    console.log('Error.mode ===> ', mode, err);
                    SDLUtil.errorAlert(err);
                    this.isSearching = false;
//                    SDLUtil.showLoadingBar(false);
                });
        },
        toggleSearching(){
          this.isSearching = true;
        },
        // More 버튼 클릭 시...
        getSearchByMoreKey(moreKey) {
            SDLUtil.showLoadingBar(true);
            let url = `${SDLUtil.API_URL}/basis/search/getSearchEngineData.skp`;
            const param = this.getSearchParam();
            return axios
                .post(url, qs.stringify(param), {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    params: { searchInfo: 'set' }
                })
                .then(resp => {
                    if (moreKey == 30) { // Engineer
                        resp.data.resultContents.engrConts.forEach(adata => {
                            this.engrTotContents.push(adata);
                        });

                        let nStart = (this.pageSize * this.engrPage) - this.pageSize; // 50
                        for (let i=nStart; i<nStart+5; i++) {
                            if (i < this.engrTotContents.length) {
                                let elm = this.engrTotContents[i];
                                this.engrContents.push(elm);
                            }
                        }

                        if (this.engrTotContents.length >= this.engrTotalCount) {
                            this.engrMoreMsg = SDLUtil.getMsgProp('FIELD.GLOBAL.TOTAL');
                        }
                    } else if (moreKey == 40) { // Customer
                        resp.data.resultContents.custConts.forEach(adata => {
                            this.custTotContents.push(adata);
                        });

                        let nStart = (this.pageSize * this.custPage) - this.pageSize; // 100
                        for (let i=nStart; i<nStart+5; i++) {
                            if (i < this.custTotContents.length) {
                                let elm = this.custTotContents[i];
                                this.custContents.push(elm);
                            }
                        }

                        if (this.custTotContents.length >= this.custTotalCount) {
                            this.custMoreMsg = SDLUtil.getMsgProp('FIELD.GLOBAL.TOTAL');
                        }
                    } else if (moreKey == 50) { // SVC Partner
                        resp.data.resultContents.svcpConts.forEach(adata => {
                            this.svcpTotContents.push(adata);
                        });

                        let nStart = (this.pageSize * this.svcpPage) - this.pageSize; // 100
                        for (let i=nStart; i<nStart+5; i++) {
                            if (i < this.svcpTotContents.length) {
                                let elm = this.svcpTotContents[i];
                                this.svcpContents.push(elm);
                            }
                        }

                        if (this.svcpTotContents.length >= this.svcpTotalCount) {
                            this.svcpMoreMsg = SDLUtil.getMsgProp('FIELD.GLOBAL.TOTAL');
                        }
                    } else if (moreKey == 60) { // Subsidiary
                        resp.data.resultContents.subsConts.forEach(adata => {
                            this.subsTotContents.push(adata);
                        });

                        let nStart = (this.pageSize * this.subsPage) - this.pageSize; // 100
                        for (let i=nStart; i<nStart+5; i++) {
                            if (i < this.subsTotContents.length) {
                                let elm = this.subsTotContents[i];
                                this.subsContents.push(elm);
                            }
                        }

                        if (this.subsTotContents.length >= this.subsTotalCount) {
                            this.subsMoreMsg = SDLUtil.getMsgProp('FIELD.GLOBAL.TOTAL');
                        }
                    } else if (moreKey == 20) { // QNA
                        resp.data.resultContents.qnaaConts.forEach(adata => {
                            this.qnaaTotContents.push(adata);
                        });

                        let nStart = (this.pageSize * this.qnaaPage) - this.pageSize; // 100
                        for (let i=nStart; i<nStart+5; i++) {
                            if (i < this.qnaaTotContents.length) {
                                let elm = this.qnaaTotContents[i];
                                this.qnaaContents.push(elm);
                            }
                        }

                        if (this.qnaaTotContents.length >= this.qnaaTotalCount) {
                            this.qnaaMoreMsg = SDLUtil.getMsgProp('FIELD.GLOBAL.TOTAL');
                        }
                    }
                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    SDLUtil.errorAlert(err);
//                    SDLUtil.showLoadingBar(false);
                });
        },
        viewAttachFiles(event, row,col) {
            $(event.target).parent('a').parent('td').parent('tr').parent('tbody').children('tr').removeClass('active');
            $(event.target).parent('a').parent('td').parent('tr').addClass('active');
            const param = { modelCode: row.BMODEL_ID,exportView:row.headId };
            let url = `${SDLUtil.API_URL}/basis/search/getBomPdfFilesByModel.skp`;
            // 3D Exploded View disabled
            // if(col == 'CNT_3DEXPVW'){
            //     url = `${SDLUtil.API_URL}/basis/search/getThreeDBomPdfFilesByModel.skp`;
            // }
            return axios
                .post(url, qs.stringify(param), {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    params: { searchInfo: 'set' }
                })
                .then(resp => {
                    // if(col == 'CNT_3DEXPVW'){
                    //     this.qcdnAttachFiles.push(resp.data[1]) ;
                    // }else{

                    // }
                    this.qcdnAttachFiles = resp.data;
                })
                .catch(err => {
                    SDLUtil.errorAlert(err);
                });
        },

        async initFilesLoad(knowId) {
            SDLUtil.showLoadingBar(true);
            if (SDLUtil.isNull(knowId)) {
                SDLUtil.showLoadingBar(false);
                SDLUtil.alert({
                    title: "TITLE.GLOBAL.POPUP.ALERT",  // Alert
                    msg: "MESSAGE.FILE.NOSELECTFILE",   // No file is choosed.
                    okLabel: "BUTTON.GLOBAL.CLOSE",     // Close
                    onOkEvt : () => { this.$emit('close'); }
                });
            } else {
                return await fetchAttachList({ BOARD_ID: knowId });
            }
        },
        fileDownload(ndx, data) {
            SDLUtil.showLoadingBar(true);
            let boardId = this.columns[ndx].boardId;
            let headerNm = this.columns[ndx].headerNm;
            const param = {boardId: boardId, modelId: data.BMODEL_ID};
            const url = `${SDLUtil.API_URL}/basis/search/getKnowledgeIds.skp`;
            return axios
                .post(url, qs.stringify(param), {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    params: { searchInfo: 'set' }
                })
                .then(resp => {
                    SDLUtil.show(
                        AttachFilePopup, {
                            title: headerNm,
                            knowledgeInfos: resp.data,
                        }, {  // component params
                            height: 'auto'
                        }   // dialog params
                    );
                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    SDLUtil.errorAlert(err);
                });
        },
        popupBomOpen(row) {
            const url = `${SDLUtil.API_URL}/basis/search/redirectBomView.skp`;
            return axios
                .post(url, qs.stringify({ modelCode: row.BMODEL_ID }), {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    params: { searchInfo: 'set' }
                })
                .then(resp => {
                    SDLUtil.openLegacyWindowPopup({
                        url: resp.data,
                        title: 'SAMSUNG.COM SUPPORTED',
                        w: 850,
                        h: 720
                    });
                })
                .catch(err => {
                    SDLUtil.errorAlert(err);
                });
        },
        popupHtmlOpen(file) {
          SDLUtil.openLegacyWindowPopup({
              url: 'http://downloadcenter.samsung.com/content/' + file.BOM_PATH,
              title: 'SAMSUNG.COM SUPPORTED',
              w: 850,
              h: 620
          });
          let modelCd = file.MODEL_CD;
          // 3D Exploded View disabled
          // const tdRegex = /^TD\//;
          // if(tdRegex.test(file.FILE_DIR)) {
          //   SDLUtil.showLoadingBar(true);
          //   return axios.post(
          //       `${SDLUtil.API_URL}/basis/search/saveTdWebViewClickCount.skp`,
          //        qs.stringify({
          //           model_TD: modelCd,
          //           fileType: 'TD',
          //        }),
          //     )
          //     .then(resp => {
          //         SDLUtil.showLoadingBar(false);
          //     })
          //     .catch(err => {
          //         Vue.$log.error(err);
          //         SDLUtil.errorAlert(err);
          //         SDLUtil.showLoadingBar(false);
          //     });
          // }
        },
        clickQcModel(modelCode) {
            EventBus.$emit('search-reset-keyword', {keyword: modelCode});
        },
        loadMoreSearch() {
            if (this.qcdnLoadCount < this.qcdnTotalCount) {
                this.qcdnPage += 1;
                this.isLoaded = 1;
                SDLUtil.showLoadingBar(true);
                this.getDataFromServer(1); // Local DB
            } else {
                this.qcdnMoreMsg = SDLUtil.getMsgProp('FIELD.GLOBAL.TOTAL');
            }
        },
        dispMoreCont(totConts, conts, page) {
            let bServerLoad = false;
            let nStart = this.pageSize * page;
            if (nStart < this.serverSize) {
                for (let i=nStart; i<nStart+5; i++) {
                    if (i < totConts.length) {
                        let elm = totConts[i];
                        conts.push(elm);
                    }
                }
            } else bServerLoad = true;

            return bServerLoad;
        },
        loadMoreCont(moreKey, nCount) {
            let bServerLoad = false;
            if (nCount == 0) return;

            this.moreKey = moreKey;
            if (moreKey == 30 && this.engrContents.length < nCount) {
                if (this.engrPage < 20) bServerLoad = this.dispMoreCont(this.engrTotContents, this.engrContents, this.engrPage);
                else                    bServerLoad = true;
                this.engrPage += 1;
                this.contPage = this.engrPage;
                this.setButtonMsg(30, this.engrTotalCount, this.engrContents);
            } else if (moreKey == 40 && this.custContents.length < this.custTotalCount) {
                if (this.custPage < 20) bServerLoad = this.dispMoreCont(this.custTotContents, this.custContents, this.custPage);
                else                    bServerLoad = true;
                this.custPage += 1;
                this.contPage = this.custPage;
                this.setButtonMsg(40, this.custTotalCount, this.custContents);
            } else if (moreKey == 50 && this.svcpContents.length < this.svcpTotalCount) {
                if (this.svcpPage < 20) bServerLoad = this.dispMoreCont(this.svcpTotContents, this.svcpContents, this.svcpPage);
                else                    bServerLoad = true;
                this.svcpPage += 1;
                this.contPage = this.svcpPage;
                this.setButtonMsg(50, this.svcpTotalCount, this.svcpContents);
            } else if (moreKey == 60 && this.subsContents.length < this.subsTotalCount) {
                if (this.subsPage < 20) bServerLoad = this.dispMoreCont(this.subsTotContents, this.subsContents, this.subsPage);
                else                    bServerLoad = true;
                this.subsPage += 1;
                this.contPage = this.subsPage;
                this.setButtonMsg(60, this.subsTotalCount, this.subsContents);
            } else if (moreKey == 20 && this.qnaaContents.length < this.qnaaTotalCount) {
                if (this.qnaaPage < 20) bServerLoad = this.dispMoreCont(this.qnaaTotContents, this.qnaaContents, this.qnaaPage);
                else                    bServerLoad = true;
                this.qnaaPage += 1;
                this.contPage = this.qnaaPage;
                this.setButtonMsg(20, this.qnaaTotalCount, this.qnaaContents);
            } else {
                console.log('No more data...!!');
                return;
            }

            if (bServerLoad) this.getSearchByMoreKey(moreKey);

        },
        validation() {
            let param = this.getSearchParam();
            let bRes = true;
            if (param.keyword.trim().length < 2) {
                SDLUtil.alert('MESSAGE.SEARCH.INPUT.KWORD');
                this.$refs.kword.focus();
                bRes = false;
            }
            if (param.screenMode == 'D') {
                let frDate = SDLUtil.convertDate(param.frDate).replace(/-/g, '');
                let toDate = SDLUtil.convertDate(param.toDate).replace(/-/g, '');
                if (Number(toDate) < Number(frDate)) {
                    SDLUtil.alert('MESSAGE.DATE.VALIDATION.START.END');
                    return false;
                }
            }

            return bRes;
        },
        getSearchParam() {
            const param = {
                  searchKind    : this.params.searchKind
                , screenMode    : this.params.screenMode
                , keyword       : this.params.keyword
                , corpNo        : $('#selectRhqSubCd').val()
                , page          : this.qcdnPage
                , perPage       : this.pageSize
                , relResearch   : this.relResearch
                , sortBy        : this.sortBy
                , startNum      : this.startNum
                , contName      : this.contName
                , cateName      : this.cateName
                , corpName      : this.corpName
                , contPage      : this.contPage
                , moreKey       : this.moreKey
            };
            if (this.params.screenMode == 'D') {
                param.advProduct = this.params.advProduct;
                param.frDate     = this.params.FR_DT;
                param.toDate     = this.params.TO_DT;
            }
            if (this.relResearch == 'Y') {
                param.sympCode     = this.sympCode;
                param.sympDesc     = this.sympDesc;
                param.sympTypeCode = this.sympTypeCode;
            }
            return param;
        },
        getSamsungDotCom(page, only) {
            if (page == 1) $('.srch_dotcom').show();
            else       SDLUtil.showLoadingBar(true);

            if (page > 1 && this.dtcmContents.length >= this.dtcmTotalCount) {
                SDLUtil.showLoadingBar(false);
                return;
            }

            this.keyword = this.params.keyword;
            let firstYn = (page == 1) ? 'Y' : 'N';
            let start = (page -1) * 5;
            let xhr = new XMLHttpRequest();
//          xhr.responseType = 'json';
            if (!this.siteCd || this.siteCd.length == 0) {
                this.siteCd = (this.corpName) ? nationMap[this.corpName] : nationMap[this.userCorpCd] || 'uk';
            }
            let param = 'siteCd=' + this.siteCd + '&keyword=' + this.keyword + '&start=' + start + '&num=5&sort=more_relevant&stage=live&firstSearchYN=' + firstYn;
//            let param = 'siteCd=uk&keyword=' + this.keyword + '&start=' + start + '&num=5&sort=more_relevant&stage=live&firstSearchYN=' + firstYn;
            let url  = 'https://esapi.samsung.com/support/search/query?' + param;

            if (this.contName && this.contName.length > 3) {
                let conType = this.contName.split('$')[1];
                url = url + '&contentType=' + conType;
            }
//            console.log('dotcom.url ==> ', url);
            xhr.open('GET', url);
            xhr.onreadystatechange = () => {
//                console.log('xhr ===> ', xhr);
                if (xhr.readyState == 4 && xhr.status == 200) {
//                  let respObj = xhr.response;
                    let respObj = JSON.parse(xhr.response);
                    // console.log('Dotcom.resultData ==> ', respObj.response.resultData);
                    if (!respObj.response.resultData.resultList || respObj.response.resultData.resultList.length == 0) {
                        this.dotcomNavis = null;
                        if (page == 1) $('.srch_dotcom').hide();
                        else      SDLUtil.showLoadingBar(false);
                        return;
                    }
                    let thisContent = respObj.response.resultData.resultList[1].contentList;

                    let naviGroups = [];
                    respObj.response.resultData.navGroups.forEach(elm => {
                        if (elm.categoryFilterName == 'contentType') {
                            naviGroups  = elm.srpFilter;
                            return;
                        }
                    });

                    let dotCnt = 0;
                    naviGroups.forEach(elm => {
                        elm.naviName = elm.filterLocalName;
                        elm.naviCnt  = elm.filterCount;
                        dotCnt += Number(elm.filterCount);
                        elm.naviCode = elm.filterSearchCode;
                    });

                    if (thisContent) {
                        // 일단 저장해 뒀다가 검색엔진에서 Contents Navigation 검색 후에 추가.
                        this.dotcomNavis = {naviName: 'Samsung.com', naviCnt: dotCnt, naviCode: '0000', naviSubs: naviGroups};

                        thisContent.forEach(elm => {
                            this.dtcmContents.push(elm);
                        });
                    } else {
                        this.dtcmContents = [];
                    }

                    // LeftSnb - dotcom 클릭시 국가단독으로 실행
                    if (only) this.setContentTypeNavi();

                    if (page == 1) this.dtcmTotalCount = respObj.response.resultData.resultList[1].resultCount;
                    this.dtcmPage++;

                    if (page == 1) $('.srch_dotcom').hide();
                    else      SDLUtil.showLoadingBar(false);

                    // More 버튼 클릭 시...
                    if (page > 1 && this.dtcmContents.length >= this.dtcmTotalCount) {
                        this.dtcmMoreMsg = SDLUtil.getMsgProp('FIELD.GLOBAL.TOTAL');
                    }
                } else if (xhr.status != 200 && xhr.status != 0) {
                    $('.srch_dotcom').hide();
                    console.log('Error Code: ' + xhr.status + ', Message : ' + xhr.statusText);
                }
            };
            xhr.send(null); //get방식일때 null
        },
        onTotalSearch(page, initMode) {
            this.$nextTick(() => {
                EventBus.$emit('knowledge-recommend-hide');
            });

            if (this.params.keyword.trim().length < 3) {
                SDLUtil.alert('MESSAGE.SEARCH.INPUT.KWORD');
                return true;
            }

            if (this.params.screenMode == 'D') {
                let frDate = SDLUtil.convertDate(this.params.FR_DT).replace(/-/g, '');
                let toDate = SDLUtil.convertDate(this.params.TO_DT).replace(/-/g, '');
                if (Number(toDate) < Number(frDate)) {
                    SDLUtil.alert('MESSAGE.DATE.VALIDATION.START.END');
                    return true;
                }
            }

            // 검색 파라메터 로컬 스토리지에 저장
            this.saveLocalStorage();

            this.qcdnPage = 1;

            if (!this.validation()) return;

//            SDLUtil.showLoadingBar(true);
//            this.isLoaded = 0;
            this.initReset();

            // 일단, 최근 검색어 등록
            const url = `${SDLUtil.API_URL}/basis/search/saveRecentModel.skp`;
            this.execServer(url, {searchKind: this.params.searchKind, keyword : this.params.keyword}, 0);

            // 이단, DB 검색결과 가져오기
            this.qcdnLoadCount = 0;
            this.qcdnAttachFiles = [];
            this.getDataFromServer(1); // Local DB

            // samsung.com 조회
            this.getSamsungDotCom(1);

            // 삼단, 검색엔진 조회
            this.relResearch  = 'N';
            this.sympCode     = '';
            this.sympDesc     = '';
            this.sympTypeCode = '';
            this.getDataFromServer(2, initMode); // Search Engine

            return;
        },
        // 검색창에서 엔터 또는 [Search] 버튼 클릭 시..
        callSearchFunc(param, initMode) {
            this.params     = param;
            this.contName   = '';
            this.cateName   = '';
            this.corpName   = '';
            this.moreKey    = '';
            this.contPage   = '1';

            this.onTotalSearch(1, true);
        },
        searchSortBy(sortKey) {
            this.sortBy = sortKey;
            this.contPage   = '1';
            this.onTotalSearch(1, false); // LeftSnb 무시
        },
        remakeNoDupStr(str) {
            let kWords = str.split(' ');
            let newStr = '';
            kWords.forEach(str => {
                if (newStr.indexOf(str) < 0) {
                    newStr += ' ' + str;
                }
            });
            return newStr;
        },
        clickRelSearchWord(rel) {
            this.relResearch  = 'Y';
            this.sympCode     = rel.sympCode;
            this.sympDesc     = rel.sympDesc;
            this.sympTypeCode = rel.sympTypeCode;
            this.isLoaded = 1;
            this.initReset();
            let relWord = rel.sympDesc.replace(/\(/g, ' ').replace(/\)/g, ' ').trim();
            relWord = this.remakeNoDupStr(relWord);
            let param = {keyword: this.keyword + relWord, searchKind: 'K'};
            EventBus.$emit('search-reset-keyword', param);

            this.params.searchKind = 'K';
            this.getDataFromServer(2); // Search Engine
            this.params.keyword = param.keyword;
        },
        getIconClass(icon) {
            let iconClass = '';
            if (icon == 'R')
                iconClass = 'textbgbox_recommend';
            else if (icon == 'H')
                iconClass = 'textbgbox_hot';
            else if (icon == 'N')
                iconClass = 'textbgbox_new';
            else if (icon == 'U')
                iconClass = 'textbgbox_update';
            else iconClass = '';

            return iconClass;
        },
        // 즐겨찾기 추가
        addFavorite(event, cont, mode) {
            const param = { workCd: (mode == 'F') ? 21 : 29, workCdSeq : cont.keyId, flMode: mode};
            let url = '';
            // 즐겨찾기는 toggle 방식
            if (mode == 'F') { // 즐겨찾기(Favorite)
                if ($(event.target).hasClass('off')) {
                    $(event.target).removeClass('off');
                    url = `${SDLUtil.API_URL}/basis/common/scrap/scrap.skp`;
                    this.execServer(url, param, 2);
                } else {
                    $(event.target).addClass('off');
                    url = `${SDLUtil.API_URL}/basis/common/scrap/deleteScrap.skp`;
                    this.execServer(url, param, 3);
                }
            }

            // 좋아요(Like)는 한번 하면 땡~
            if (mode == 'L' && !cont.bLiked) { // Like(Recommend)
                if ($(event.target).hasClass('off')) {
                    $(event.target).removeClass('off');
                    url = `${SDLUtil.API_URL}/basis/common/scrap/recommend.skp`;
                    this.execServer(url, param, 4);
                }
            }
        },
        changeTab(e, cont) {
            var tabIndex = $('.tab_menus > li > a').index(e.target);
            if( $(e.target).hasClass('on') == true){
                $(e.target).parents('li').removeClass('on');
                $('.tab_wrap .tab_cont').hide();
            } else {
                $('.tab_wrap li').removeClass('on');
                $('.tab_wrap .tab_cont').hide();
                $(e.target).parents('li').addClass('on');
                $('.tab_wrap .tab_cont').eq(tabIndex).show();

                if ((tabIndex % 4) == 1) {
                    let mdlId = this.modelGridId + cont.keyId;
                    let grid = this.$refs[mdlId][0].$refs[mdlId];
                    this.resultCount = this.modelList.length;
                    grid.invoke('resetData', this.modelList);
                    grid.invoke('refreshLayout');
                } else if ((tabIndex % 4) == 2) {
                    let prtId = this.partsGridId + cont.keyId;
                    let grid = this.$refs[prtId][0].$refs[prtId];
                    this.resultCount = this.partsList.length;
                    grid.invoke('resetData', this.partsList);
                    grid.invoke('refreshLayout');
                } else if ((tabIndex % 4) == 3) {
                    this.resultCount = this.versionList.length;
                } else {
                    this.resultCount = 999;
                }
            }
            EventBus.$emit('grid-refresh');
        },
        showDetailInfo($event, cont) {
            let li = $(event.target).parents('li');
            let isActive = $(li).hasClass('active');
            this.resultCount = 999;

            // 모든 섹션에서 닫히게...
            $('.view_desc').parent('li').removeClass('active');
            $('.conts').parent('li').removeClass('active'); // Q&A 섹션
            if (isActive) { // 상세 div 닫기
                $(li).removeClass('active');

                // Recommend Popup (2020.06.16)
                this.$nextTick(() => {
                    EventBus.$emit('knowledge-recommend-hide');
                });
            } else { // 상세 div 열기
                $(li).addClass('active');
                this.loadDetailInfo(cont);
                cont.active = cont.keyId;
            }

            if (cont.MODELS) {
                cont.MODELS = false;
            } else {
                cont.MODELS = true;
            }
        },
        stripHtml(html) {
            var tmp = document.createElement('html');
            tmp.innerHTML = html;
            return tmp.textContent || tmp.innerText || '';
        },
        loadQuestInfo(cont) {
            SDLUtil.showLoadingBar(true);
            return axios
                .post(
                    `${SDLUtil.API_URL}/skp/basis/myKnowledge/myQnA/myQuestion/myQuestionDetailView.skp`,
                    qs.stringify({ questionId: cont.keyId, systemId: 'SKP' }),
                    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
                )
                .then(resp => {
//                  this.$nextTick(() => {
                    this.QNA_DESCR = resp.data.question.questionDesc.replace(/\n/g, '<br>');

                    // 질문 첨부파일
                    if (resp.data.attach && resp.data.attach.rowData.length > 0) {
                        this.QST_ATTACHES = resp.data.attach.rowData;
                    } else {
                        this.QST_ATTACHES = [];
                    }

                    let reply = resp.data.proAnswer;
                    if (reply && reply.rowData.length > 0) {
                        this.QNA_REPLY = resp.data.proAnswer.rowData[0].ANSDESC;
                    }
                    // 답변 첨부파일
                    if (resp.data.proAttach && resp.data.proAttach.rowData.length > 0) {
                        this.ANS_ATTACHES = resp.data.proAttach.rowData;
                    } else {
                        this.ANS_ATTACHES = [];
                    }
//                  });
                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
        showQnaInfo($event, cont) {
            let li = $(event.target).parents('li'); // 상위 모든 li들...
            let isActive = $(li).hasClass('active');

            // 모든 섹션에서 닫히게...
            $('.view_desc').parent('li').removeClass('active');
            $('.conts').parent('li').removeClass('active');
            if (isActive) {
                $(li).removeClass('active');
            } else {
                $(li).addClass('active');
                this.loadQuestInfo(cont);
                cont.active = cont.keyId;
            }
        },
        loadDetailInfo(cont) {
            SDLUtil.showLoadingBar(true);
            return axios
                .post(
                    `${SDLUtil.API_URL}/basis/knowledge/knowledgeDetail.skp`,
                    qs.stringify({ KNOWLEDGE_ID: cont.keyId, mList: '', boardId: cont.boardId }),
                    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
                )
                .then(resp => {
                    this.symptomList    = resp.data.symptomList.rowData;
                    this.serialList     = resp.data.serialList.rowData;
                    this.modelList      = resp.data.modelList.rowData;
                    this.partsList      = resp.data.strParts.rowData;
                    this.detail         = resp.data.detail.rowData[0];
                    this.KNOWLEDGE_DESC = this.detail.KNOWLEDGE_DESC; // .replace(/\n/g, '<br>');
                    this.contAttaches   = resp.data.attach.rowData;
                    this.versionList    = resp.data.version.rowData;
                    this.isScmsContent  = StringUtil.strToBool(this.detail['SCMS_YN']);

                    EventBus.$emit('grid-search');

                    // Recommend Popup (2020.06.16)
                    this.$nextTick(() => {
                        EventBus.$emit('knowledge-recommend-show', { knowledgeId: cont.keyId, scmsYn: this.isScmsContent });
                    });

                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
//                    this.$router.go(-1);
                });
        },
        changeQdnModel() {
            if (this.selModelCd) {
                this.quickDownloads.forEach(elm => {
                    if (elm.BMODEL_ID == this.selModelCd) {
                        this.selModels = elm.subValues;
                    }
                });
            } else {
                this.selModels = null;
            }
        },
        callFuncSearchBySnb(param) {
            this.contName   = param.contName;
            this.cateName   = param.cateName;
            this.corpName   = param.corpName;
            this.moreKey    = '';
//            this.siteCd     = param.siteCd;
            this.onTotalSearch(1, false);
        },
        reloadSamsungDotcom(event, siteCd) {
            let $el = $(event.target).parent('div').children('a').removeClass('active');
            $(event.target).addClass('active');

            this.siteCd = siteCd;
            this.dtcmPage    = 1;
            this.dotcomNavis = null;
            this.dtcmTotalCount = -1;
            this.dtcmContents = [];
            this.getSamsungDotCom(1, true);
        },
        getDownloadUrl(SEQ, TOKEN) {
            let cmnApiBase = `${SDLUtil.API_URL}/basis/common/attachDownload.skp`;
            return window.open(cmnApiBase + '?attachFileSeq=' + SEQ + '&encToken=' + TOKEN);
        },
        getDownloadUrlOld(SEQ, TOKEN) {
            let cmnApiBase = `${SDLUtil.API_URL}/basis/common/attachDownload.skp` + '?attachFileSeq=' + SEQ + '&encToken=' + TOKEN;
            return cmnApiBase;
        },
        toggleLink(e) {
            $('.attachment_link > dd').toggle();
        },
        saveLocalStorage() {
            localStorage.setItem('search.keyword',      this.params.keyword);
            localStorage.setItem('search.screenMode',   this.params.screenMode);
            localStorage.setItem('search.searchMode',   this.params.searchMode);
            localStorage.setItem('search.searchKind',   this.params.searchKind);
            localStorage.setItem('search.FR_DT',        this.params.FR_DT);
            localStorage.setItem('search.TO_DT',        this.params.TO_DT);
            localStorage.setItem('search.prodCateCd1',  this.params.prodCateCd1);
            localStorage.setItem('search.prodCateCd2',  this.params.prodCateCd2);
            localStorage.setItem('search.prodCateCd3',  this.params.prodCateCd3);
        },
        goMain() {
            this.$router.push({ path: `${SDLUtil.WEB_CONTEXT_PATH}/` });
        },
        getNationsBySubsidiary() {
            let url = `${SDLUtil.API_URL}/basis/admin/dotcom/getNationsByCorp.skp`;
            const param = {corpNo : $('#selectRhqSubCd').val()};
            return axios.post(url, qs.stringify(param), {
                   headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                   params: { searchInfo: 'set' }
                })
                .then(resp => {
                    this.dotcomNations = resp.data.rows;
                    console.log('this.dotcomNations ==> ', this.dotcomNations);
                    if (this.dotcomNations && this.dotcomNations.length > 0) {
                        this.siteCd = this.dotcomNations[0].SITE_CD;
                    } else {
                        this.siteCd = 'uk';
                    }
                    this.onTotalSearch(1, true); // 조회하면서 들어온다.
                    this.$nextTick(() => {
                        $('.samsung_title').children('div').children('a:first').addClass('active');
                    });
                });
        },
        btnPrint(knowledgeId) {
            SDLUtil.show(
                ContPrintPopup,
                {
                    KNOWLEDGE_ID: knowledgeId
                },
                { height: 'auto' }
            );
        }

    }, // methods
    watch: { // keyword를 clearable로 지웠을 때...
        // Change of date unit
    },
    created() {
        this.params = this.$route.query; // 검색팝업에서 받은 params
        this.saveLocalStorage();

        let remWid = 410;
        // Mobile
        if($(window).width() < 1024) remWid = 180;

        this.irxWidth = $(window).width() - remWid;
        EventBus.$on('search-snb-reload', pObj => { this.callFuncSearchBySnb(pObj); });
    },
    mounted() {
//        $('.srch_relword').hide();
        $('.quick_downs').hide();
        $('.srch_engine').hide();
        $('.srch_dotcom').hide();
        this.params.searchKind = this.params.searchKind;
        this.params.screenMode = this.params.screenMode;
        this.keyword           = this.params.keyword;

        // Samsung.com 국가 목록
        this.getNationsBySubsidiary();

//        this.onTotalSearch(1, true); // 조회하면서 들어온다.
    },
    beforeDestroy() {
        EventBus.$off('search-snb-reload');
    },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/skpComponents/view/basis/intgSearch/SearchList.vue